import axiosClient from 'api/axiosClient';
import chargeModelApi from 'api/chargeModelApi';
import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import { AnimatePresence, motion } from 'framer-motion';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTRadio, {
  KTRadioType,
} from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import CustomDropdown2, { CustomDropdown2Directions } from 'general/components/Others/CustomDropdown2';
import EmptyView from 'general/components/Others/EmptyView';
import ImageView from 'general/components/quybka/Images/ImageView';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import AgencySaleDialogView from '../AgencySaleDialogView';
import AgencySaleOrderWizardView from '../AgencySaleOrderWizardView';
import ChargeHelper from 'features/Charge/chargeHelper';
import useAppConfig from 'hooks/useAppConfig';
import AgencySaleAddPremiseView from '../AgencySaleAddPremiseView';
import { AppDialogHelper } from 'general/components/AppDialog';
import AppConstants from 'general/constants/AppConstants';
import DealerHelper from 'features/ManageDealer/dealerHelper';

AgencySaleAddOrderView.propTypes = {
  initialAgencySaleId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(null),
  ]),
  initialAgencyInvestorId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(null),
  ]),
  initialAgencyCoinvestorId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(null),
  ]),
  initialAgencyGroupId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(null),
  ]),
  removePadding: PropTypes.bool,
  initialAsSeller: PropTypes.bool,
};

AgencySaleAddOrderView.defaultProps = {
  initialAgencySaleId: null,
  initialAgencyInvestorId: null,
  initialAgencyCoinvestorId: null,
  initialAgencyGroupId: null,
  removePadding: false,
  initialAsSeller: false,
};

function AgencySaleAddOrderView(props) {
  // MARK: ---- PROPERTIES ----
  const { initialAgencySaleId, initialAgencyInvestorId, initialAgencyCoinvestorId, initialAgencyGroupId, initialAgencyLandlordId, initialAgencyChargePointId, initialAsSeller, removePadding } = props;
  const router = useRouter();
  const saleId = router.query?.saleId;
  const editMode = !!saleId;
  const [canEdit, setCanEdit] = useState(false);
  const [readyToValidData, setReadyToValidData] = useState(false);
  const [saleDetail, setSaleDetail] = useState(null);
  useEffect(() => {
    if (saleId) {
      requestGetSaleDetail(saleId);
    }
  }, [saleId]);
  useEffect(() => {
    if (Utils.isValid(saleDetail)) {
      setCanEdit(saleDetail?.status === AgencyConstants.SaleOrderStatus.ORDERED && !saleDetail?.contracts?.length);
    } else {
      setCanEdit(true);
    }
  }, [saleDetail]);
  const [productType, setProductType] = useState('CHARGE_MODEL');
  useEffect(() => {
    if (initialAgencyGroupId) {
      setProductType('INVESTMENT_PACKAGE');
    } else if (initialAgencyInvestorId) {
      setProductType('CHARGE_MODEL');
    } else if (initialAgencyCoinvestorId) {
      setProductType('COINVESTOR');
    } else if (initialAgencyLandlordId) {
      setProductType('PREMISE')
    } else if (initialAgencyChargePointId) {
      setProductType('CHARGEPOINT');
    }
  }, [initialAgencySaleId, initialAgencyInvestorId, initialAgencyCoinvestorId, initialAgencyGroupId, initialAgencyLandlordId, initialAgencyChargePointId]);
  const canChangeProductType = useMemo(() => {
    return !(initialAgencyGroupId || initialAgencyInvestorId || initialAgencyLandlordId || initialAgencyChargePointId || initialAgencyCoinvestorId);
  }, [initialAgencyGroupId, initialAgencyInvestorId, initialAgencyLandlordId, initialAgencyChargePointId, initialAgencyCoinvestorId]);
  const isBuyerPrefilled = useMemo(() => {
    if (initialAsSeller) {
      return false;
    }
    return !!(initialAgencyInvestorId || initialAgencyCoinvestorId || initialAgencyGroupId || initialAgencyLandlordId || initialAgencyChargePointId);
  }, [initialAsSeller, initialAgencyInvestorId, initialAgencyCoinvestorId, initialAgencyGroupId, initialAgencyLandlordId, initialAgencyChargePointId]);
  const isSellerPrefilled = useMemo(() => {
    return initialAsSeller && !!(initialAgencyInvestorId || initialAgencyCoinvestorId);
  }, [initialAsSeller, initialAgencyInvestorId, initialAgencyCoinvestorId]);
  const sellerDropdownMenuItems = useMemo(() => {
    const items = [
      { name: 'Đại lý', role: AgencyConstants.AgencyRole.SALE },
      { name: 'Nhà đầu tư HTKD', role: AgencyConstants.AgencyRole.GROUP },
      { name: 'Nhà đầu tư NQ', role: AgencyConstants.AgencyRole.INVESTOR },
      { name: 'Nhà đầu tư liên kết', role: AgencyConstants.AgencyRole.COINVESTOR },
    ];

    if (productType === 'CHARGE_MODEL' || productType === 'COINVESTOR') {
      return items.filter((item) => item.role !== AgencyConstants.AgencyRole.GROUP);
    }

    return items;
  }, [productType]);

  useEffect(() => {
    setSelectedInvestor(null);
    setFilterAllInvestorList({
      q: '',
      role: productType === 'CHARGE_MODEL'
        ? 'INVESTOR'
        : productType === 'INVESTMENT_PACKAGE'
          ? 'GROUP'
          : productType === 'PREMISE'
            ? 'LANDLORD'
            : productType === 'COINVESTOR'
              ? 'COINVESTOR'
              : productType === 'CHARGE_POINT'
                ? 'CHARGE_POINT'
                : '',
    });
  }, [productType]);
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const isAgency = user?.role === 'AGENCY';
  const isSale = user?.agency?.primaryRole === AgencyConstants.AgencyRole.SALE;
  const [contractDate, setContractDate] = useState(moment().format('YYYY-MM-DD'));
  const [contractNumber, setContractNumber] = useState('');
  const [orderStatus, setOrderStatus] = useState(AgencyConstants.SaleOrderStatus.ORDERED);
  const [note, setNote] = useState('');
  const [validFrom, setValidFrom] = useState(moment().format('YYYY-MM-DD'));
  const [validTo, setValidTo] = useState(moment().add(10, 'year').format('YYYY-MM-DD'));
  const [amount, setAmount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [amountAfterTax, setAmountAfterTax] = useState(0);
  const [chargeModelAmount, setChargeModelAmount] = useState(0);
  const [categoryAmount, setCategoryAmount] = useState(0);
  const [modeOnlySubInvestor, setModeOnlySubInvestor] = useState(true);
  const [productTypeOption, setProductTypeOption] = useState();
  const [showProductTypeOptions, setShowProductTypeOptions] = useState(true);
  const [defaultOpenProductTypeOptions, setDefaultOpenProductTypeOptions] = useState(false);
  const canChangeStatus = useMemo(() => {
    return saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD && _.first(saleDetail?.contracts)?.status === AgencyConstants.ContractStatus.AGENCY_SIGNED
  }, [saleDetail])
  const adminRole =
    user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;

  useEffect(() => {
    if (!adminRole && (productType === 'PREMISE' || productType === 'CHARGEPOINT')) {
      setModeOnlySubInvestor(false);
    }
  }, [adminRole, productType])
  // ds hang tru sac
  const [chargeBrandList, setChargeBrandList] = useState([]);
  useEffect(() => {
    ChargeHelper.API.requestGetChargeBrandList({}).then((data) => {
      const { brands } = data;
      setChargeBrandList(brands);
    });
  }, []);
  const productOptions = [
    { name: 'Trụ sạc', value: 'CHARGE_MODEL_PRODUCT', id: 'CHARGE_MODEL_PRODUCT', role: 'CHARGE_MODEL_PRODUCT', hasThirdLevel: true },
    { name: 'Trang thiết bị & dịch vụ', value: 'CATEGORY_PRODUCT', id: 'CATEGORY_PRODUCT', role: 'CATEGORY_PRODUCT', hasThirdLevel: false },
  ];
  const productTypeRef = useRef(null);
  const chargeBrandOptions = useMemo(() => {
    return chargeBrandList?.map((row) => {
      return {
        name: row?.name,
        role: row?.brandId,
      };
    });
  }, [chargeBrandList]);
  // ds dong tru sac
  const [chargeModelList, setChargeModelList] = useState([]);
  useEffect(() => {
    chargeModelApi.getChargeModelList({}).then((data) => {
      const { result, models } = data;
      if (result === 'success') {
        setChargeModelList(models);
      }
    });
  }, []);
  const chargeModelOptions = useMemo(() => {
    return chargeModelList?.map((row) => {
      return {
        name: `[${row?.type}] ${row?.name}`,
        value: row?.modelId,
      };
    });
  }, [chargeModelList]);
  const [selectedChargeModelList, setSelectedChargeModelList] = useState([
    {
      modelId: null,
      amount: 0,
      serialNumber: '',
      model: '',
      type: '',
      connectorType: '',
      quantity: 1,
      unit: '',
      taxRate: 0,
      tax: 0,
      amountBeforeTax: 0,
    },
  ]);
  const [selectedChargePointList, setSelectedChargePointList] = useState([
    {
      modelId: null,
      amount: 0,
      serialNumber: '',
      model: '',
      type: '',
      connectorType: '',
      quantity: 1,
    },
  ]);
  // ds goi dau tu HTKD
  const [investmentPackageList, setInvestmentPackageList] = useState([]);
  useEffect(() => {
    const getInvestmentPackageList = async (params) => {
      const res = await axiosClient.get('/investment/package', { params });
      const { result, packages, total } = res;
      if (result === 'success') {
        setInvestmentPackageList([
          {
            amount: 0,
            name: 'Tuỳ chọn',
            packageId: 0,
          },
          ...packages,
        ]);
      }
    };
    getInvestmentPackageList({});
  }, []);
  const investmentPackageOptions = useMemo(() => {
    const packageOptions = investmentPackageList?.map((row) => {
      return {
        name: row?.name,
        value: row?.packageId,
      };
    });
    return packageOptions;
  }, [investmentPackageList]);
  const [selectedInvestmentPackage, setSelectedInvestmentPackage] = useState(null);
  const [selectedInvestmentPackageAmount, setSelectedInvestmentPackageAmount] = useState(0);
  useEffect(() => {
    setSelectedInvestmentPackageAmount(selectedInvestmentPackage?.amount ?? 0);
  }, [selectedInvestmentPackage]);
  // ds mat bang
  const [premiseList, setPremiseList] = useState([]);
  const [premiseType, setPremiseType] = useState('NEW_PREMISE');
  useEffect(() => {
    AgencyHelper.API.requestGetPremiseList({}).then((data) => {
      const { premises } = data;
      setPremiseList(premises);
    });
  }, []);
  const premiseOptions = useMemo(() => {
    return premiseList?.map((row) => {
      return {
        name: row?.name,
        value: row?.premiseId,
      };
    });
  }, [premiseList]);
  const [selectedPremise, setSelectedPremise] = useState(
    {
      premiseId: null,
      name: '',
      type: '',
      floorArea: '',
      vehicleTypes: '',
      rentingType: 'FULL',
      parkingSlots: 0,
      rentalForm: 'Có phí',
      areaId: null,
      address: '',
      description: '',
      monthlyRent: 0,
      slotRent: 0,
    }
  );
  // ds nha dieu hanh
  const operatorList = useSelector((state) => state?.app?.appConfig?.operators) ?? [];
  const operatorOptions = useMemo(() => {
    return operatorList?.map((row) => {
      return {
        title: row?.name,
        subTitle: row?.description,
        value: row?.operatorId,
      };
    });
  }, [operatorList]);
  const [selectedOperator, setSelectedOperator] = useState(null);
  useEffect(() => {
    if (operatorList.length > 0) {
      setSelectedOperator(operatorList[0]);
    }
  }, [operatorList]);
  const [allInvestorList, setAllInvestorList] = useState([]);
  const [filterAllInvestorList, setFilterAllInvestorList] = useState({
    q: '',
    role: '',
  });
  useEffect(() => {
    const getInvestorList = async (params) => {
      if (filterAllInvestorList.q?.length > 0) {
        const response = await AgencyHelper.API.requestSearchAgency(filterAllInvestorList);
        setAllInvestorList(response.agencies);
      }
    };
    getInvestorList(filterAllInvestorList);
  }, [filterAllInvestorList]);
  const allInvestorOptions = useMemo(() => {
    return allInvestorList?.map((row) => {
      return {
        title: row?.agencyId + ' - ' + row?.name,
        subTitle: row?.description,
        value: row?.agencyId,
      };
    });
  }, [allInvestorList]);
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [investorReadyToPurchase, setInvestorReadyToPurchase] = useState(true);
  const investorInfoNeedToPurchase = useRef([]);
  useEffect(() => {
    if (selectedInvestor?.item?.primaryRole === 'INVESTOR') return;
    const arrInfoNeedToPurchase = AgencyHelper.Utils.checkAgencyEnoughInfoToPurchase(
      selectedInvestor?.item
    );
    const isEditable = isAdmin || selectedInvestor?.item?.parentAgencyId === user?.agency?.agencyId;
    const isReady = _.isEmpty(arrInfoNeedToPurchase);
    investorInfoNeedToPurchase.current = arrInfoNeedToPurchase;
    setInvestorReadyToPurchase(isReady);
    if (!isReady) {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogNoticeTriangular} />}
          title={`Chưa có đủ thông tin ${infoTitleMap[productType]}`}
          contentEl={
            <>
              Vui lòng cập nhật đầy đủ thông tin của {infoTitleMap[productType]} {' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                {selectedInvestor?.name}
              </span>{' '}
              để có thể tạo đơn hàng. Thông tin còn thiếu:{' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                {investorInfoNeedToPurchase.current?.join(', ')}
              </span>
            </>
          }
          cancelButtonText="Bỏ qua"
          confirmButtonText={modeOnlySubInvestor && isEditable ? 'Cập nhật thông tin' : null}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={() => {
            AppCustomDialogHelper.hide();
            AgencyHelper.Navigation.navigateToAgencyEdit(null, selectedInvestor?.item);
          }}
        />,
        'md',
        false,
        true
      );
    }
  }, [selectedInvestor, editMode, isAdmin]);

  useEffect(() => {
    const checkFranchiseContract = async () => {
      if (selectedInvestor?.item?.primaryRole !== 'INVESTOR') return;

      try {
        const contracts = await AgencyHelper.API.requestGetContractList({
          agencyId: selectedInvestor?.id,
          contractRole: AgencyConstants.ContractRole.FRANCHISE,
          status: AgencyConstants.ContractStatus.COMPLETED,
        });
        if (!contracts?.length) {
          setInvestorReadyToPurchase(false);
          AgencyHelper.UI.showDialogRequireFranchiseContract(
            selectedInvestor?.item,
            () => {
              setInvestorReadyToPurchase(true);
            }
          );
        } else {
          setInvestorReadyToPurchase(true);
        }
      } catch (error) {
        console.error('Failed to check franchise contract:', error);
      }
    };

    checkFranchiseContract();
  }, [selectedInvestor]);

  // ds dai ly ban hang
  const [selectedAgency, setSelectedAgency] = useState(null);
  useEffect(() => {
    if (isAgency && !initialAsSeller && !initialAgencySaleId) {
      setSelectedAgency({
        id: user?.agency?.agencyId,
        name: user?.agency?.name,
        item: user?.agency,
      });
    }
  }, [user, isAgency, initialAsSeller, initialAgencySaleId]);
  useEffect(() => {
    if (initialAgencySaleId) {
      AgencyHelper.API.requestAgencyDetail(initialAgencySaleId).then((data) => {
        setSelectedAgency({
          id: data?.agencyId,
          name: data?.name,
          item: data,
        });
      });
    }
  }, [initialAgencySaleId]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const selectFilePathList = useRef([]);
  const [allFiles, setAllFiles] = useState([]);
  const [contractList, setContractList] = useState([]);
  useEffect(() => {
    if (saleDetail) {
      setOrderStatus(saleDetail?.status);
      setContractDate(saleDetail?.contractDate);
      setContractNumber(saleDetail?.contractNumber);
      setNote(saleDetail?.note ?? '');
      setValidFrom(saleDetail?.items[0]?.investment?.validFrom);
      setValidTo(saleDetail?.items[0]?.investment?.validTo);
      if (saleDetail?.orderType === AgencyConstants.SaleOrderType.GROUP) {
        setSelectedInvestmentPackage(saleDetail?.items[0]?.investment);
      } else if (saleDetail?.orderType === AgencyConstants.SaleOrderType.INVESTOR || saleDetail?.orderType === AgencyConstants.SaleOrderType.COINVESTOR) {
        let items = saleDetail?.items?.map((item) => {
          return {
            modelId: item?.modelId,
            amount: item?.amountBeforeTax,
            serialNumber: item?.serialNumber,
            serial: item?.serialNumber,
            model: item?.chargeModel?.name,
            type: item?.chargeModel?.type,
            connectorType: item?.chargeModel?.connectorType,
            unit: item?.unit ?? 'Trụ',
            taxRate: Math.round(item?.taxRate * 100),
            productType: 'CHARGE_MODEL_PRODUCT',
          };
        });
        let inventoryItems = saleDetail?.inventoryItems?.map((inventoryItem) => {
          return {
            modelId: inventoryItem?.categoryId,
            amount: inventoryItem?.priceBeforeTax,
            model: inventoryItem?.name,
            quantity: inventoryItem?.quantity,
            unit: inventoryItem?.category?.unit,
            taxRate: Math.round(inventoryItem?.taxRate * 100),
            productType: 'CATEGORY_PRODUCT',
          };
        });
        items = items.reduce((acc, item) => {
          const existingItem = acc.find((i) => i.modelId === item.modelId);
          if (existingItem) {
            existingItem.quantity += 1;
          } else {
            acc.push({ ...item, quantity: 1 });
          }
          return acc;
        }, []);
        setSelectedChargeModelList([...items, ...inventoryItems]);
        if (saleDetail?.serviceAmount) {
          setCategoryAmount(saleDetail?.serviceAmount);
        }
      } else if (saleDetail?.orderType === AgencyConstants.SaleOrderType.LANDLORD) {
        let item = {
          premiseId: saleDetail?.premise?.premiseId,
          name: saleDetail?.premise?.name,
          type: saleDetail?.premise?.type,
          floorArea: saleDetail?.premise?.floorArea,
          vehicleTypes: saleDetail?.premise?.vehicleTypes?.join(','),
          parkingSlots: saleDetail?.premise?.parkingSlots,
          rentingType: saleDetail?.premise?.rentingType,
          rentalForm: saleDetail?.premise ? handleGetRentingForm(saleDetail?.premise) : 'Có phí',
          areaId: saleDetail?.premise?.areaId,
          address: saleDetail?.premise?.address,
          description: saleDetail?.premise?.description,
          monthlyRent: saleDetail?.premise?.monthlyRent,
          slotRent: saleDetail?.premise?.slotRent,
        };
        setSelectedPremise(item);
      } else if (saleDetail?.orderType === AgencyConstants.SaleOrderType.CHARGEPOINT) {
        let items = saleDetail?.items?.map((item) => {
          return {
            modelId: item?.modelId,
            amount: item?.amount,
            serialNumber: item?.serialNumber,
            serial: item?.serialNumber,
            model: item?.chargeModel?.name,
            type: item?.chargeModel?.type,
            connectorType: item?.chargeModel?.connectorType,
          };
        });
        items = items.reduce((acc, item) => {
          const existingItem = acc.find((i) => i.modelId === item.modelId);
          if (existingItem) {
            existingItem.quantity += 1;
          } else {
            acc.push({ ...item, quantity: 1 });
          }
          return acc;
        }, []);
        setSelectedChargePointList(items);
      }
      setProductType(saleDetail?.orderType === 'GROUP'
        ? 'INVESTMENT_PACKAGE'
        : saleDetail?.orderType === 'INVESTOR'
          ? 'CHARGE_MODEL'
          : saleDetail?.orderType === 'COINVESTOR'
            ? 'COINVESTOR'
            : saleDetail?.orderType === 'LANDLORD'
              ? 'PREMISE'
              : 'CHARGEPOINT'
      );
      if (productType !== AgencyConstants.SaleOrderType.INVESTOR && productType !== AgencyConstants.SaleOrderType.COINVESTOR) {
        setAmount(saleDetail?.amount);
      }
      setAllFiles(saleDetail?.attachedFiles ?? []);

      setContractList(saleDetail?.contracts ?? []);
      // const buyerId = saleDetail?.buyerId;
      // const saleId = saleDetail?.saleId;
      // AgencyHelper.API.requestGetContractList(saleId, buyerId).then((data) => {
      //   if (data) {
      //     setContractList(data);
      //   }
      // });
    }
  }, [saleDetail]);
  useEffect(() => {
    if (saleDetail) {
      AgencyHelper.API.requestAgencyDetail(saleDetail?.buyerId).then((data) => {
        setSelectedInvestor({
          id: data?.agencyId,
          name: data?.name,
          item: data,
        });
      });
      AgencyHelper.API.requestAgencyDetail(saleDetail?.agencyId).then((data) => {
        setSelectedAgency({
          id: data?.agencyId,
          name: data?.name,
          item: data,
        });
      });
    } else {
      if (initialAgencySaleId) {
        AgencyHelper.API.requestAgencyDetail(initialAgencySaleId).then((data) => {
          setSelectedAgency({
            id: data?.agencyId,
            name: data?.name,
            item: data,
          });
        });
      }
      if (initialAgencyInvestorId) {
        AgencyHelper.API.requestAgencyDetail(initialAgencyInvestorId).then((data) => {
          const agencyValue = {
            id: data?.agencyId,
            name: data?.name,
            item: data,
          };
          if (initialAsSeller) {
            setSelectedAgency(agencyValue);
          } else {
            setSelectedInvestor(agencyValue);
          }
        });
      }
      if (initialAgencyCoinvestorId) {
        AgencyHelper.API.requestAgencyDetail(initialAgencyCoinvestorId).then((data) => {
          const agencyValue = {
            id: data?.agencyId,
            name: data?.name,
            item: data,
          };
          if (initialAsSeller) {
            setSelectedAgency(agencyValue);
          } else {
            setSelectedInvestor(agencyValue);
          }
        });
      }
      if (initialAgencyGroupId) {
        AgencyHelper.API.requestAgencyDetail(initialAgencyGroupId).then((data) => {
          setSelectedInvestor({
            id: data?.agencyId,
            name: data?.name,
            item: data,
          });
        });
      }
      if (initialAgencyLandlordId) {
        AgencyHelper.API.requestAgencyDetail(initialAgencyLandlordId).then((data) => {
          setSelectedInvestor({
            id: data?.agencyId,
            name: data?.name,
            item: data,
          });
        });
      }
      if (initialAgencyChargePointId) {
        AgencyHelper.API.requestAgencyDetail(initialAgencyChargePointId).then((data) => {
          setSelectedInvestor({
            id: data?.agencyId,
            name: data?.name,
            item: data,
          });
        });
      }
    }
  }, [saleDetail]);
  useEffect(() => {
    if (productType === 'INVESTMENT_PACKAGE') {
      setAmount(selectedInvestmentPackageAmount);
    } else if (productType === 'CHARGE_MODEL') {
      setAmount(0);
      setTaxAmount(0);
      setAmountAfterTax(0);
    } else if (productType === 'COINVESTOR') {
      setAmount(0);
      setTaxAmount(0);
      setAmountAfterTax(0);
    } else if (productType === 'PREMISE') {
      setAmount(0);
    } else if (productType === 'CHARGEPOINT') {
      setAmount(0);
      setTaxAmount(0);
      setAmountAfterTax(0);
    }
  }, [selectedInvestmentPackageAmount, productType]);
  useEffect(() => {
    if (!selectedChargeModelList.length) {
      setChargeModelAmount(0);
      setAmount(0);
      setTaxAmount(0);
      setAmountAfterTax(0);
      return;
    }

    const calculateAmounts = (productType) => {
      const amounts = selectedChargeModelList.reduce(
        (acc, item) => {
          const baseAmount = (item?.amount ?? 0) * (item?.quantity ?? 0);
          const taxRate = item?.taxRate ?? 0;
          const taxAmount = Math.round(baseAmount * taxRate / 100);
          const amountAfterTax = Math.round(baseAmount * (1 + taxRate / 100));

          return {
            amount: acc.amount + baseAmount,
            taxAmount: acc.taxAmount + taxAmount,
            amountAfterTax: acc.amountAfterTax + amountAfterTax,
          };
        },
        { amount: 0, taxAmount: 0, amountAfterTax: 0 }
      );
      return amounts;
    };

    const chargeModel = calculateAmounts("CHARGE_MODEL_PRODUCT");
    // const category = calculateAmounts("CATEGORY_PRODUCT");
    setChargeModelAmount(chargeModel.amount);
    // setCategoryAmount(category.amount);
    setAmount(chargeModel.amount);
    setTaxAmount(chargeModel.taxAmount);
    setAmountAfterTax(chargeModel.amountAfterTax + (Number(categoryAmount) || 0));
  }, [selectedChargeModelList, categoryAmount]);
  useEffect(() => {
    if (selectedChargePointList.length > 0) {
      const totalAmount = selectedChargePointList.reduce((acc, item) => {
        const itemAmount = item?.amount * item?.quantity;
        return acc + itemAmount;
      }, 0);
      setAmount(totalAmount);
    }
  }, [selectedChargePointList]);
  const [buyerDropdownMenuItems, setBuyerDropdownMenuItems] = useState([]);
  const [buyerDropdownDefaultItem, setBuyerDropdownDefaultItem] = useState({});
  useEffect(() => {
    setBuyerDropdownMenuItems([
      {
        name: 'NĐT liên kết',
        role: AgencyConstants.AgencyRole.GROUP,
      },
      {
        name: 'NĐT nhượng quyền',
        role: AgencyConstants.AgencyRole.INVESTOR,
      },
      {
        name: 'Nhà đầu tư liên kết',
        role: AgencyConstants.AgencyRole.COINVESTOR,
      },
      {
        name: 'Chủ mặt bằng',
        role: AgencyConstants.AgencyRole.LANDLORD,
      },
    ]);
    if (productType === 'INVESTMENT_PACKAGE') {
      setBuyerDropdownDefaultItem({
        name: 'NĐT liên kết',
        role: AgencyConstants.AgencyRole.GROUP,
        modeOnlySubInvestor,
      });
    } else if (productType === 'CHARGE_MODEL') {
      setBuyerDropdownDefaultItem({
        name: 'NĐT nhượng quyền',
        role: AgencyConstants.AgencyRole.INVESTOR,
        modeOnlySubInvestor,
      });
    } else if (productType === 'COINVESTOR') {
      setBuyerDropdownDefaultItem({
        name: 'Nhà đầu tư liên kết',
        role: AgencyConstants.AgencyRole.COINVESTOR,
        modeOnlySubInvestor,
      });
    } else if (productType === 'PREMISE') {
      setBuyerDropdownDefaultItem({
        name: 'Chủ mặt bằng',
        role: AgencyConstants.AgencyRole.LANDLORD,
        modeOnlySubInvestor,
      });
    } else if (productType === 'CHARGEPOINT' && !initialAgencyChargePointId) {
      setBuyerDropdownDefaultItem(null);
    }

  }, [productType, modeOnlySubInvestor]);
  useEffect(() => {
    if (initialAgencyChargePointId) {
      setBuyerDropdownDefaultItem({
        name: 'Bán trụ sạc',
        role: AgencyConstants.AgencyRole.CHARGEPOINT,
        modeOnlySubInvestor,
      });
    }
  }, [initialAgencyChargePointId])
  const orderStatusOptions = useMemo(() => {
    if (productType === 'INVESTMENT_PACKAGE') {
      return AgencyHelper.Data.orderStatusOptions.filter(
        (item) =>
          ![
            AgencyConstants.SaleOrderStatus.SHIPPING,
            AgencyConstants.SaleOrderStatus.INSTALLED,
            AgencyConstants.SaleOrderStatus.INSTALLING,
            AgencyConstants.SaleOrderStatus.SIGNED,
            AgencyConstants.SaleOrderStatus.COMPLETED,
            AgencyConstants.SaleOrderStatus.CANCELLED,
          ].includes(item.value)
      );
    } else if (productType === 'PREMISE') {
      const orderStatus = saleDetail?.status || AgencyConstants.SaleOrderStatus.PAID;
      return AgencyHelper.Data.premiseOrderStatusOption[orderStatus];
    } else {
      const orderStatus = saleDetail?.status || AgencyConstants.SaleOrderStatus.ORDERED;
      return AgencyHelper.Data.orderStatusOption[orderStatus];
    }
  }, [productType, AgencyHelper.Data.orderStatusOptions, AgencyHelper.Data.premiseOrderStatusOption, saleDetail]);

  const appConfig = useAppConfig();
  const [commissionGrounds, setCommissionGrounds] = useState([]);
  useEffect(() => {
    setCommissionGrounds(
      appConfig.commissionRateLandlord
        ? JSON.parse(appConfig.commissionRateLandlord)
          .map(item => ({
            key: item.key,
            name: item.name,
            value: item?.value ?? 0,
            car: item?.car ?? 0,
            bike: item?.bike ?? 0,
            show: item.show
          }))
        : [{ name: '', value: 0, car: 0, bike: 0 }]
    );
  }, [appConfig]);

  const [selectedAreaProvince, setSelectedAreaProvince] = useState();
  const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();

  const defaultLandlordMonthlyRent = appConfig.defaultLandlordMonthlyRent;
  const defaultLandlordSlotRent = appConfig.defaultLandlordSlotRent;

  const infoTitleMap = {
    PREMISE: 'chủ mặt bằng',
    CHARGEPOINT: 'đối tác',
    CHARGE_MODEL: 'nhà đầu tư',
    COINVESTOR: 'nhà đầu tư',
    INVESTMENT_PACKAGE: 'nhà đầu tư',
  };

  // MARK: ---- METHODS ----
  const requestGetSaleDetail = async (saleId) => {
    const sale = await AgencyHelper.API.requestGetSaleDetail(saleId);
    if (sale) {
      setSaleDetail(sale);
    }
  };
  const handleSave = async () => {
    if (!investorReadyToPurchase) {
      if (selectedInvestor?.item?.primaryRole === 'INVESTOR') {
        AgencyHelper.UI.showDialogRequireFranchiseContract(
          selectedInvestor?.item,
          () => {
            setInvestorReadyToPurchase(true);
          }
        );
        return;
      } else {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogNoticeTriangular} />}
            title={`Chưa có đủ thông tin ${infoTitleMap[productType]}`}
            contentEl={
              <>
                Vui lòng cập nhật đầy đủ thông tin của {infoTitleMap[productType]} {' '}
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                  {selectedInvestor?.name}
                </span>{' '}
                để có thể tạo đơn hàng. Thông tin còn thiếu:{' '}
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                  {investorInfoNeedToPurchase.current?.join(', ')}
                </span>
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Cập nhật thông tin"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={() => {
              AppCustomDialogHelper.hide();
              AgencyHelper.Navigation.navigateToAgencyEdit(null, selectedInvestor?.item);
            }}
          />,
          'md',
          false,
          true
        );
        return;
      }
    }

    // validate dữ liệu
    if (!_.isEmpty(selectedFiles)) {
      selectFilePathList.current = [];
      await processSelectedFiles(selectedFiles);
    }
    setAllFiles([
      ..._.filter(allFiles, (item) => typeof item === 'string'),
      ...selectFilePathList.current,
    ]);
    const attachedFiles = [
      ..._.filter(allFiles, (item) => typeof item === 'string'),
      ...selectFilePathList.current,
    ];

    if (!selectedAgency) {
      ToastHelper.showError(productType === 'PREMISE' ? 'Vui lòng chọn người giới thiệu' : 'Vui lòng chọn đối tượng bán hàng');
      return;
    }
    if (!selectedInvestor) {
      ToastHelper.showError(productType === 'PREMISE' ? 'Vui lòng chọn chủ mặt bằng' : 'Vui lòng chọn nhà đầu tư');
      return;
    }
    if (!selectedOperator) {
      ToastHelper.showError('Vui lòng chọn nhà điều hành');
      return;
    }
    if (productType === 'INVESTMENT_PACKAGE' && !selectedInvestmentPackage) {
      ToastHelper.showError('Vui lòng chọn gói đầu tư HTKD');
      return;
    }
    if (productType === 'CHARGE_MODEL' && selectedChargeModelList.some((item) => !item?.modelId)) {
      ToastHelper.showError('Vui lòng chọn sản phẩm');
      return;
    }
    if (
      (productType === 'CHARGE_MODEL' &&
        selectedChargeModelList.some((item) => item?.amount <= 0)) ||
      (productType === 'INVESTMENT_PACKAGE' && selectedInvestmentPackageAmount <= 0)
    ) {
      ToastHelper.showError('Giá không hợp lệ');
      return;
    }
    if (
      productType === 'CHARGE_MODEL' &&
      selectedChargeModelList.some((item) => item?.quantity <= 0)
    ) {
      ToastHelper.showError('Số lượng không hợp lệ');
      return;
    }
    //
    if (productType === 'COINVESTOR' && selectedChargeModelList.some((item) => !item?.modelId)) {
      ToastHelper.showError('Vui lòng chọn sản phẩm');
      return;
    }
    if (
      (productType === 'COINVESTOR' && selectedChargeModelList.some((item) => item?.amount <= 0))
    ) {
      ToastHelper.showError('Giá không hợp lệ');
      return;
    }
    if (
      productType === 'COINVESTOR' && selectedChargeModelList.some((item) => item?.quantity <= 0)
    ) {
      ToastHelper.showError('Số lượng không hợp lệ');
      return;
    }
    if (
      productType === 'PREMISE' &&
      !Utils.isValid(selectedPremise?.name)
    ) {
      ToastHelper.showError('Tên mặt bằng không hợp lệ');
      return;
    }
    if (
      productType === 'PREMISE' &&
      !Utils.isValid(selectedPremise?.type)
    ) {
      ToastHelper.showError('Loại mặt bằng không hợp lệ');
      return;
    }
    if (
      productType === 'PREMISE' &&
      (!Utils.isValid(selectedPremise?.floorArea) || selectedPremise?.floorArea <= 0)
    ) {
      ToastHelper.showError('Diện tích mặt bằng không hợp lệ');
      return;
    }
    if (
      productType === 'PREMISE' &&
      (!Utils.isValid(selectedPremise?.vehicleTypes) || !selectedPremise?.vehicleTypes?.length)
    ) {
      ToastHelper.showError('Loại phương tiện không hợp lệ');
      return;
    }
    if (
      productType === 'PREMISE' &&
      !Utils.isValid(selectedPremise?.rentingType)
    ) {
      ToastHelper.showError('Phạm vi thuê không hợp lệ');
      return;
    }
    if (
      productType === 'PREMISE'
    ) {
      if (!Utils.isValid(selectedPremise?.parkingSlots) || selectedPremise?.parkingSlots < 0) {
        ToastHelper.showError('Số chỗ đỗ xe ô tô không hợp lệ');
        return;
      } else {
        if (selectedPremise?.vehicleTypes?.split(',')?.includes('CAR') && selectedPremise?.rentingType === 'SLOT' && selectedPremise?.parkingSlots === 0) {
          ToastHelper.showError('Số chỗ đỗ xe ô tô phải lớn hơn 0');
          return;
        }
      }
    }
    if (
      productType === 'PREMISE' &&
      (!Utils.isValid(selectedPremise?.areaId) || !Utils.isValid(selectedPremise?.address))
    ) {
      ToastHelper.showError('Địa chỉ mặt bằng không hợp lệ');
      return;
    }

    if (productType === 'CHARGEPOINT' && selectedChargePointList.some((item) => !item?.modelId)) {
      ToastHelper.showError('Vui lòng chọn dòng trụ sạc');
      return;
    }
    if (productType === 'CHARGEPOINT' && selectedChargePointList.some((item) => !item?.modelId)) {
      ToastHelper.showError('Vui lòng chọn dòng trụ sạc');
      return;
    }
    if (
      (productType === 'CHARGEPOINT' &&
        selectedChargePointList.some((item) => item?.amount <= 0))
    ) {
      ToastHelper.showError('Giá không hợp lệ');
      return;
    }
    if (
      productType === 'CHARGEPOINT' &&
      selectedChargePointList.some((item) => item?.quantity <= 0)
    ) {
      ToastHelper.showError('Số lượng không hợp lệ');
      return;
    }

    // che do chinh sua don hang
    if (editMode) {
      const paramUpdateSale = {
        amount: amount,
        amountBeforeTax: amount,
        amountAfterTax: amount,
        status: orderStatus,
        note: note,
        attachedFiles: attachedFiles,
        agencyId: selectedAgency?.item?.agencyId,
        buyerId: selectedInvestor?.item?.agencyId,
      };
      if (productType === 'INVESTMENT_PACKAGE') {
        const investmentId = _.first(saleDetail?.items)?.investmentId;
        if (investmentId) {
          const paramUpdateInvestment = {
            amount: selectedInvestmentPackageAmount,
            amountBeforeTax: selectedInvestmentPackageAmount,
          };
          if (selectedInvestmentPackage?.packageId > 0) {
            paramUpdateInvestment.packageId = selectedInvestmentPackage?.packageId;
            paramUpdateInvestment.description = selectedInvestmentPackage?.description;
          } else {
            paramUpdateInvestment.packageId = null;
          }
          const investment = await AgencyHelper.API.requestUpdateInvestment(
            investmentId,
            paramUpdateInvestment
          );
          if (investment) {
            paramUpdateSale.items = [{ ...investment, amountBeforeTax: investment.amount }];
          }
        }
      } else if (productType === 'CHARGE_MODEL') {
        let items = [];
        let inventoryItems = [];
        for (const item of selectedChargeModelList) {
          // if (item?.productType === "CHARGE_MODEL_PRODUCT") {
          const quantity = item?.quantity;
          for (let i = 0; i < quantity; i++) {
            items.push({
              modelId: item?.modelId,
              amountBeforeTax: item?.amount,
              taxRate: item?.taxRate / 100,
              tax: Math.round(item?.amount * item?.taxRate / 100),
              amount: Math.round(item?.amount * (1 + item?.taxRate / 100)),
            });
          }
          // } else {
          //   inventoryItems.push({
          //     categoryId: item?.modelId,
          //     name: item?.model,
          //     quantity: item?.quantity,
          //     taxRate: item?.taxRate / 100,
          //     priceBeforeTax: item?.amount,
          //     tax: Math.round(item?.amount * item?.quantity * item?.taxRate / 100),
          //     amountBeforeTax: item?.amount * item?.quantity,
          //     price: Math.round(item?.amount * (1 + item?.taxRate / 100)),
          //     amount: Math.round(item?.amount * (1 + item?.taxRate / 100) * item?.quantity),
          //     unit: item?.unit,
          //   })
          // }
        }
        paramUpdateSale.items = items;
        paramUpdateSale.inventoryItems = inventoryItems;
        paramUpdateSale.amountBeforeTax = amount;
        paramUpdateSale.amount = amount;
        paramUpdateSale.amountAfterTax = amountAfterTax;
        paramUpdateSale.serviceAmount = Number(categoryAmount) || 0;
      } else if (productType === 'COINVESTOR') {
        let items = [];
        let inventoryItems = [];
        for (const item of selectedChargeModelList) {
          const quantity = item?.quantity;
          for (let i = 0; i < quantity; i++) {
            items.push({
              modelId: item?.modelId,
              amountBeforeTax: item?.amount,
              taxRate: item?.taxRate / 100,
              tax: Math.round(item?.amount * item?.taxRate / 100),
              amount: Math.round(item?.amount * (1 + item?.taxRate / 100)),
            });
          }
        }
        paramUpdateSale.items = items;
        paramUpdateSale.inventoryItems = inventoryItems;
        paramUpdateSale.amountBeforeTax = amount;
        paramUpdateSale.amount = amount;
        paramUpdateSale.amountAfterTax = amountAfterTax;
        paramUpdateSale.serviceAmount = Number(categoryAmount) || 0;
      } else if (productType === 'PREMISE') {
        paramUpdateSale.premiseId = selectedPremise?.premiseId;
        const selectedPremiseType = commissionGrounds?.find(commission => commission?.key === selectedPremise?.type);
        const premiseAmount = !selectedPremiseType?.show
          ? selectedPremiseType?.value
          : (selectedPremise.vehicleTypes.includes('CAR') && selectedPremise.vehicleTypes.includes('BIKE')
            ? selectedPremiseType?.car + selectedPremiseType?.bike
            : selectedPremise.vehicleTypes.includes('CAR')
              ? selectedPremiseType?.car
              : selectedPremiseType?.bike);
        paramUpdateSale.amount = premiseAmount;
        paramUpdateSale.amountBeforeTax = premiseAmount;
        paramUpdateSale.amountAfterTax = premiseAmount;
        paramUpdateSale.premiseType = {
          key: selectedPremiseType?.key,
          name: selectedPremiseType?.name,
          ...(selectedPremiseType?.show === 0 ? { value: selectedPremiseType?.value } : { car: selectedPremiseType?.car, bike: selectedPremiseType?.bike })
        };
        const res = await AgencyHelper.API.requestUpdatePremise(
          selectedPremise?.premiseId,
          Utils.transformEmptyStrings({
            name: selectedPremise.name,
            type: selectedPremise.type,
            agencyId: selectedAgency?.item?.agencyId,
            floorArea: selectedPremise.floorArea,
            vehicleTypes: selectedPremise.vehicleTypes?.split(','),
            parkingSlots: selectedPremise.parkingSlots,
            rentingType: selectedPremise.rentingType,
            areaId: selectedPremise.areaId,
            address: selectedPremise.address,
            description: selectedPremise.description,
            landlordId: selectedInvestor?.item?.agencyId,
            stationId: [],
            saleId: selectedAgency?.item?.agencyId,
            fullfillmentDate: moment().format('YYYY-MM-DD'),
          })
        );
        if (!res) {
          ToastHelper.showSuccess(`Cập nhật thông tin mặt bằng không thành công`);
        }
      } else if (productType === 'CHARGEPOINT') {
        let items = [];
        for (const item of selectedChargePointList) {
          const quantity = item?.quantity;
          for (let i = 0; i < quantity; i++) {
            items.push({
              modelId: item?.modelId,
              amount: item?.amount,
              amountBeforeTax: item?.amount,
            });
          }
        }
        paramUpdateSale.items = items;
        paramUpdateSale.quantity = 1;
        paramUpdateSale.amountBeforeTax = amount;
        paramUpdateSale.amount = amount;
        paramUpdateSale.amountAfterTax = amount;
      }

      const result = await AgencyHelper.API.requestUpdateSale(saleId, paramUpdateSale);
      if (_.isBoolean(result) && result === true) {
        ToastHelper.showSuccess('Cập nhật đơn hàng thành công');
        router.navigate(-1);
      } else {
        ToastHelper.showError(result || 'Cập nhật đơn hàng không thành công');
      }
      return;
    }

    // che do tao don hang
    const paramCreateAgencySale = {
      orderType: productType === 'INVESTMENT_PACKAGE'
        ? 'GROUP'
        : productType === 'CHARGE_MODEL'
          ? 'INVESTOR'
          : productType === 'COINVESTOR'
            ? 'COINVESTOR'
            : productType === 'PREMISE'
              ? 'LANDLORD'
              : 'CHARGEPOINT',
      operatorId: selectedOperator?.operatorId,
      agencyId: selectedAgency?.item?.agencyId,
      buyerId: selectedInvestor?.item?.agencyId,
      status: orderStatus,
      attachedFiles: attachedFiles,
      note: note,
    };

    if (productType === 'INVESTMENT_PACKAGE') {
      const paramCreateInvestment = {
        operatorId: selectedOperator?.operatorId,
        agencyId: selectedInvestor?.item?.agencyId,
        sellerId: selectedAgency?.item?.agencyId,
        amount: selectedInvestmentPackageAmount,
        amountBeforeTax: selectedInvestmentPackageAmount,
        currency: 'VND',
        description: selectedInvestmentPackage?.description,
        packageId:
          selectedInvestmentPackage?.packageId > 0 ? selectedInvestmentPackage?.packageId : null,
        status: AgencyConstants.InvestmentStatus.PENDING,
        note: note,
        attachedFiles: attachedFiles,
      };
      const investment = await AgencyHelper.API.requestCreateInvestment(paramCreateInvestment);
      if (!investment) {
        ToastHelper.showError('Tạo investment không thành công');
        return;
      }
      paramCreateAgencySale.items = [{ ...investment, amountBeforeTax: investment.amount }];
      paramCreateAgencySale.amount = selectedInvestmentPackageAmount;
      paramCreateAgencySale.amountBeforeTax = selectedInvestmentPackageAmount;
      paramCreateAgencySale.amountAfterTax = selectedInvestmentPackageAmount;
    } else if (productType === 'CHARGE_MODEL') {
      let items = [];
      let inventoryItems = [];
      for (const item of selectedChargeModelList) {
        // if (item?.productType === "CHARGE_MODEL_PRODUCT") {
        const quantity = item?.quantity;
        for (let i = 0; i < quantity; i++) {
          items.push({
            modelId: item?.modelId,
            amountBeforeTax: item?.amount,
            taxRate: item?.taxRate / 100,
            tax: Math.round(item?.amount * item?.taxRate / 100),
            amount: Math.round(item?.amount * (1 + item?.taxRate / 100)),
          });
        }
        // } else {
        //   inventoryItems.push({
        //     categoryId: item?.modelId,
        //     name: item?.model,
        //     quantity: item?.quantity,
        //     taxRate: item?.taxRate / 100,
        //     priceBeforeTax: item?.amount,
        //     tax: Math.round(item?.amount * item?.quantity * item?.taxRate / 100),
        //     amountBeforeTax: item?.amount * item?.quantity,
        //     price: Math.round(item?.amount * (1 + item?.taxRate / 100)),
        //     amount: Math.round(item?.amount * (1 + item?.taxRate / 100) * item?.quantity),
        //     unit: item?.unit,
        //   })
        // }
      }
      paramCreateAgencySale.items = items;
      paramCreateAgencySale.inventoryItems = inventoryItems;
      paramCreateAgencySale.amountBeforeTax = amount;
      paramCreateAgencySale.amount = amount;
      paramCreateAgencySale.amountAfterTax = amountAfterTax;
      paramCreateAgencySale.serviceAmount = Number(categoryAmount) || 0;
    } else if (productType === 'COINVESTOR') {
      let items = [];
      let inventoryItems = [];
      for (const item of selectedChargeModelList) {
        const quantity = item?.quantity;
        for (let i = 0; i < quantity; i++) {
          items.push({
            modelId: item?.modelId,
            amountBeforeTax: item?.amount,
            taxRate: item?.taxRate / 100,
            tax: Math.round(item?.amount * item?.taxRate / 100),
            amount: Math.round(item?.amount * (1 + item?.taxRate / 100)),
          });
        }
      }
      paramCreateAgencySale.items = items;
      paramCreateAgencySale.inventoryItems = inventoryItems;
      paramCreateAgencySale.amountBeforeTax = amount;
      paramCreateAgencySale.amount = amount;
      paramCreateAgencySale.amountAfterTax = amountAfterTax;
      paramCreateAgencySale.serviceAmount = Number(categoryAmount) || 0;
    } else if (productType === 'PREMISE') {
      if (premiseType === 'CREATED_PREMISE') {
        paramCreateAgencySale.premiseId = selectedPremise?.premiseId;
        const selectedPremiseType = commissionGrounds?.find(commission => commission?.key === selectedPremise?.type);
        const premiseAmount = !selectedPremiseType?.show
          ? selectedPremiseType?.value
          : (selectedPremise.vehicleTypes.includes('CAR') && selectedPremise.vehicleTypes.includes('BIKE')
            ? selectedPremiseType?.car + selectedPremiseType?.bike
            : selectedPremise.vehicleTypes.includes('CAR')
              ? selectedPremiseType?.car
              : selectedPremiseType?.bike);
        paramCreateAgencySale.amount = premiseAmount;
        paramCreateAgencySale.amountBeforeTax = premiseAmount;
        paramCreateAgencySale.amountAfterTax = premiseAmount;
        paramCreateAgencySale.premiseType = {
          key: selectedPremiseType?.key,
          name: selectedPremiseType?.name,
          ...(selectedPremiseType?.show === 0 ? { value: selectedPremiseType?.value } : { car: selectedPremiseType?.car, bike: selectedPremiseType?.bike })
        };
        const res = await AgencyHelper.API.requestUpdatePremise(
          selectedPremise?.premiseId,
          Utils.transformEmptyStrings({
            agencyId: selectedAgency?.item?.agencyId,
          })
        );
        if (!res) {
          ToastHelper.showSuccess(`Cập nhật thông tin mặt bằng không thành công`);
        }
      } else if (premiseType === 'NEW_PREMISE') {
        const res = await AgencyHelper.API.requestCreatePremise(
          Utils.transformEmptyStrings({
            name: selectedPremise.name,
            type: selectedPremise.type,
            agencyId: selectedAgency?.item?.agencyId,
            floorArea: selectedPremise.floorArea,
            vehicleTypes: selectedPremise.vehicleTypes?.split(','),
            parkingSlots: selectedPremise.parkingSlots,
            rentingType: selectedPremise.rentingType,
            areaId: selectedPremise.areaId,
            address: selectedPremise.address,
            description: selectedPremise.description,
            landlordId: selectedInvestor?.item?.agencyId,
            stationId: [],
            saleId: selectedAgency?.item?.agencyId,
            status: 'AVAILABLE',
            fullfillmentDate: moment().format('YYYY-MM-DD'),
            monthlyRent: selectedPremise.rentingType === 'FULL'
              ? defaultLandlordMonthlyRent ?? 0
              : (defaultLandlordSlotRent * selectedPremise.parkingSlots) ?? 0,
            slotRent: selectedPremise.rentingType === 'FULL'
              ? null
              : defaultLandlordSlotRent ?? 0
          })
        );
        if (res && _.isObject(res)) {
          paramCreateAgencySale.premiseId = res?.premiseId;
          const selectedPremiseType = commissionGrounds?.find(commission => commission?.key === res?.type);
          const premiseAmount = !selectedPremiseType?.show
            ? selectedPremiseType?.value
            : (res.vehicleTypes.includes('CAR') && res.vehicleTypes.includes('BIKE')
              ? selectedPremiseType?.car + selectedPremiseType?.bike
              : res.vehicleTypes.includes('CAR')
                ? selectedPremiseType?.car
                : selectedPremiseType?.bike);
          paramCreateAgencySale.amount = premiseAmount;
          paramCreateAgencySale.amountBeforeTax = premiseAmount;
          paramCreateAgencySale.amountAfterTax = premiseAmount;
          paramCreateAgencySale.premiseType = {
            key: selectedPremiseType?.key,
            name: selectedPremiseType?.name,
            ...(selectedPremiseType?.show === 0 ? { value: selectedPremiseType?.value } : { car: selectedPremiseType?.car, bike: selectedPremiseType?.bike })
          };
        } else {
          ToastHelper.showError(res || 'Tạo mặt bằng không thành công');
          return;
        }
      }
    }
    else if (productType === 'CHARGEPOINT') {
      let items = [];
      for (const item of selectedChargePointList) {
        const quantity = item?.quantity;
        for (let i = 0; i < quantity; i++) {
          items.push({
            modelId: item?.modelId,
            amount: item?.amount,
            amountBeforeTax: item?.amount,
          });
        }
      }
      paramCreateAgencySale.items = items;
      paramCreateAgencySale.amount = amount;
      paramCreateAgencySale.amountBeforeTax = amount;
      paramCreateAgencySale.amountAfterTax = amount;
    }

    const agencySale = await AgencyHelper.API.requestCreateSale(paramCreateAgencySale);
    if (agencySale && _.isObject(agencySale)) {
      ToastHelper.showSuccess('Tạo đơn hàng thành công');
      if (isAdmin) {
        router.navigate(`${AppRoute.orderList}/${agencySale?.saleId}`);
      } else if (isAgency) {
        if (
          AgencyHelper.Utils.checkRole(user?.agency, AgencyConstants.AgencyRole.GROUP) ||
          AgencyHelper.Utils.checkRole(user?.agency, AgencyConstants.AgencyRole.INVESTOR) ||
          AgencyHelper.Utils.checkRole(user?.agency, AgencyConstants.AgencyRole.COINVESTOR)
        ) {
          router.navigate(AppRoute.saleOrder);
        } else {
          router.navigate(AppRoute.agencyOrderList);
        }
      }
    } else {
      ToastHelper.showError(agencySale || 'Tạo agency sale không thành công');
      return;
    }
  };
  const handleCancel = () => {
    router.navigate(-1);
  };
  const handleFilesChanged = (e) => {
    const newFiles = Array.from(e.target.files || []);
    if (!newFiles.length) return;

    setSelectedFiles((prev) => {
      const validNewFiles = newFiles.filter((file) => {
        if (file.name.length > 128) {
          ToastHelper.showError(`Tên file quá dài! Tối đa cho phép 128 ký tự.`);
          return false;
        }
        return !prev.some((p) => p.name === file.name);
      });

      if (!validNewFiles.length) return prev;

      const updated = [...prev, ...validNewFiles];

      setAllFiles((prevAll) => {
        const reallyNew = validNewFiles.filter(
          (f) => !prevAll.some((p) => p.name === f.name)
        );
        return [...prevAll, ...reallyNew];
      });

      return updated;
    });

    e.target.value = null;
  };
  const handleRemoveAll = () => {
    setSelectedFiles([]);
  };
  const handleViewFile = (file) => {
    const url = URL.createObjectURL(file);
    if (url) {
      Utils.openInNewTab(url);
      URL.revokeObjectURL(url);
    }
  };
  const handleRemoveFile = (file) => {
    if (file instanceof File) {
      const tmpFiles = selectedFiles.filter((item) => item.lastModified !== file?.lastModified);
      setSelectedFiles(tmpFiles);
    }

    let newAllFiles = [...allFiles];
    if (typeof file === 'string') {
      newAllFiles = _.filter(allFiles, (item) => item !== file);
    }
    if (file instanceof File) {
      newAllFiles = _.filter(allFiles, (item) => item.lastModified !== file?.lastModified);
    }
    setAllFiles(newAllFiles);
  };
  async function processSelectedFiles(files) {
    for (const file of files) {
      const path = await uploadAsyncFunction(file);
      selectFilePathList.current?.push(path);
    }
  }
  async function uploadAsyncFunction(file) {
    return new Promise((resolve) => {
      if (file instanceof File) {
        miscHelper.callApiUploadFile(file).then((mediaList) => {
          if (_.isArray(mediaList) && mediaList.length > 0) {
            const firstMedia = _.first(mediaList);
            const relativePath = firstMedia?.relativePath;
            if (relativePath) {
              resolve(relativePath);
            } else {
              resolve(null);
            }
          } else {
            resolve(null);
          }
        });
      } else {
        resolve(file);
      }
    });
  }
  const handleSerialChange = (index, newSerial) => {
    const updatedList = [...selectedChargeModelList];
    updatedList[index] = {
      ...updatedList[index],
      serial: newSerial,
    };
    setSelectedChargeModelList(updatedList);
  };

  const handleCheckSelectedPremise = (premise) => {
    if (!!premise?.agencyId && premise?.sales?.length) {
      AppDialogHelper.show(
        `Mặt bằng đã tồn tại đơn hàng`,
        `Mặt bằng này đã tồn tại đơn hàng. Vui lòng chọn mặt bằng khác.`,
        [
          {
            title: 'Hủy bỏ',
            type: 'neutral',
            onClick: () => {
              AppDialogHelper.hide();
              return false;
            },
          },
        ],
        false,
        AppResource.images.dialogIcons.dialogDeleteVehicle
      );
    } else {
      return true;
    }
  }
  const handleGetRentingForm = (row) => {
    const landlordCommission = row?.landlord?.commissions?.find(
      (commission) => commission?.role === 'LANDLORD'
        && row?.chargeStations?.length && row?.chargeStations?.some(station => station?.stationId === commission?.stationId)
    );

    if (!row) return 'Không xác định';

    const hasMonthlyRent = row.monthlyRent > 0;
    const hasLandlordCommission = !!landlordCommission;

    if (!hasMonthlyRent && !hasLandlordCommission || landlordCommission?.energyCommissionValue === 0) return 'Miễn phí';
    if (!hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Có phí';
    if (hasMonthlyRent && !hasLandlordCommission || landlordCommission?.energyCommissionValue === 0) return 'Có phí';
    if (hasMonthlyRent && hasLandlordCommission && landlordCommission?.energyCommissionValue > 0) return 'Có phí';

    return 'Không xác định';
  };

  return (
    <div
      className=""
      style={{
        minHeight: '900px',
      }}
    >
      {/* breadcrumb */}
      {isAdmin &&
        !removePadding &&
        UIHelper.buildBreadcrumb([
          {
            title: 'Quản lý đơn hàng',
            onPress: () => router.navigate(AppRoute.orderList),
          },
          { title: editMode ? 'Chỉnh sửa đơn hàng' : 'Tạo đơn hàng' },
        ])}
      <div className={removePadding ? '' : 'container-fluid px-4 my-4'}>
        {isAdmin ||
          AgencyHelper.Utils.checkRole(user?.agency, AgencyConstants.AgencyRole.SALE) ||
          AgencyHelper.Utils.checkRole(user?.agency, AgencyConstants.AgencyRole.GROUP) ||
          AgencyHelper.Utils.checkRole(user?.agency, AgencyConstants.AgencyRole.INVESTOR) ||
          AgencyHelper.Utils.checkRole(user?.agency, AgencyConstants.AgencyRole.COINVESTOR) ? (
          <>
            {/* header */}
            {UIHelper.buildCard(
              <div className="">
                <div className="d-flex flex-row align-items-center justify-content-between px-5 py-4">
                  <div className="d-flex flex-column gap-2">
                    <span
                      style={{
                        fontSize: '18px',
                        fontWeight: '600',
                        color: AppColors.gray[800],
                      }}
                    >
                      {editMode ? 'Chỉnh sửa đơn hàng' : 'Tạo đơn hàng'}
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-3">
                    {UIHelper.buildNegativeButton('Hủy bỏ', handleCancel)}
                    {UIHelper.buildGreenButton('Lưu đơn hàng', handleSave)}
                  </div>
                </div>

                {/* wizards */}
                <AgencySaleOrderWizardView
                  orderItem={saleDetail}
                  contractItem={_.maxBy(contractList, 'contractId')}
                  orderType={
                    productType === 'CHARGE_MODEL'
                      ? AgencyConstants.SaleOrderType.INVESTOR
                      : productType === 'COINVESTOR'
                        ? AgencyConstants.SaleOrderType.COINVESTOR
                        : productType === 'INVESTMENT_PACKAGE'
                          ? AgencyConstants.SaleOrderType.GROUP
                          : productType === 'PREMISE'
                            ? AgencyConstants.SaleOrderType.LANDLORD
                            : AgencyConstants.SaleOrderType.CHARGEPOINT
                  }
                />
              </div>
            )}

            {/* thong tin san pham & thong tin don hang */}
            <div className="mt-4">
              <div className="row m-0">
                {/* thong tin san pham */}
                <div className="col-lg-8 p-0">
                  {UIHelper.buildCard(
                    <div>
                      {/* chon loai san pham */}
                      {UIHelper.buildCardHeader('Thông tin sản phẩm:')}
                      <div className="radio-inline w-100 px-4">
                        <div className="d-flex align-items-center gap-4">
                          <KTRadio
                            name="typeChargeModel"
                            label="Nhượng quyền"
                            type={KTRadioType.outline}
                            additionalClassName="radio-success"
                            onChange={(value) => {
                              setProductType('CHARGE_MODEL');
                            }}
                            checked={productType === 'CHARGE_MODEL'}
                            disabled={editMode || !canChangeProductType}
                          />
                          <KTRadio
                            name="typeCoinvestor"
                            label="Liên kết"
                            type={KTRadioType.outline}
                            additionalClassName="radio-success"
                            onChange={(value) => {
                              setProductType('COINVESTOR');
                            }}
                            checked={productType === 'COINVESTOR'}
                            disabled={editMode || !canChangeProductType}
                          />
                          {/* <KTRadio
                            name="typePremise"
                            label="Giới thiệu mặt bằng"
                            type={KTRadioType.outline}
                            additionalClassName="radio-success"
                            onChange={(value) => {
                              setProductType('PREMISE');
                            }}
                            checked={productType === 'PREMISE'}
                            disabled={editMode || !canChangeProductType}
                          />
                          <KTRadio
                            name="typeChargePoint"
                            label="Bán trụ sạc"
                            type={KTRadioType.outline}
                            additionalClassName="radio-success"
                            onChange={(value) => {
                              setProductType('CHARGEPOINT');
                            }}
                            checked={productType === 'CHARGEPOINT'}
                            disabled={editMode || !canChangeProductType}
                          /> */}
                        </div>
                      </div>

                      {/* danh sach san pham */}
                      <AnimatePresence mode="wait">
                        <motion.div
                          key={productType}
                          initial={{ y: 10, opacity: 0 }}
                          animate={{ y: 0, opacity: 1 }}
                          exit={{ y: -10, opacity: 0 }}
                          transition={{ duration: 0.2 }}
                        >
                          {/* san pham tru sac */}
                          {(productType === 'CHARGE_MODEL' || productType === 'COINVESTOR') && (
                            <div className="mb-4">
                              <div className="table-responsive">
                                <table className="table mb-0">
                                  <thead>
                                    <tr>
                                      {[
                                        { label: 'Sản phẩm', isRequired: true, className: 'pl-5' },
                                        { label: 'Đơn vị tính', isRequired: true },
                                        { label: 'Số lượng', isRequired: true },
                                        { label: 'Đơn giá', isRequired: true },
                                        { label: 'Thành tiền', isRequired: true },
                                        { label: 'Thuế suất', isRequired: true },
                                        { label: '', className: 'pr-5 w-40px' },
                                      ].map((col, idx) => (
                                        <th
                                          key={idx}
                                          className={col.className ?? ''}
                                          style={{
                                            ...UIHelper.buildFontStyle(
                                              '600',
                                              '12px',
                                              AppColors.gray[900]
                                            ),
                                            backgroundColor: AppColors.gray[100],
                                            borderTop: `1px solid ${AppColors.gray[300]}`,
                                            borderBottom: `1px solid ${AppColors.gray[300]}`,
                                          }}
                                        >
                                          {UIHelper.buildFormLabel(col.label, col.isRequired)}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {selectedChargeModelList.map((item, index) => {
                                      return (
                                        <tr key={`MODEL_${index}`} className="">
                                          <td
                                            className="border-0 pl-5 mb-0 pb-0 pr-0"
                                            style={{
                                              minWidth: '200px',
                                            }}
                                          >
                                            <CustomDropdown2
                                              ignoreConfirmClick={true}
                                              name={`MODEL_${index}`}
                                              id={`MODEL_${index}`}
                                              toggleElement={
                                                <button
                                                  className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!canEdit ? 'disabled' : ''
                                                    }`}
                                                  type="button"
                                                >
                                                  {item?.modelId
                                                    ? `[${item?.type}] ${item?.model}`
                                                    : 'Chọn dòng trụ sạc'}
                                                </button>
                                              }
                                              selectedValue={item}
                                              dropdownMenuItems={chargeBrandOptions}
                                              dropdownMenuClassName="overflow-auto w-100 position-relative"
                                              dropdownMenuStyle={{ maxHeight: '30vh' }}
                                              titleSearchable={true}
                                              defaultTitle="Chọn hãng sản xuất trụ sạc"
                                              getSubItems={async (item) => {
                                                return chargeModelApi.getChargeModelList(
                                                  Utils.filterParams({
                                                    brandId: item?.role,
                                                    page: item?.page || 0,
                                                    limit: 10,
                                                    q: item?.q || '',
                                                  })
                                                ).then((data) => {
                                                  let values = data.models?.map((row) => ({
                                                    id: row?.modelId,
                                                    name: `[${row?.type}] ${row?.name}`,
                                                    value: 'CHARGE_MODEL_PRODUCT',
                                                    productType: 'CHARGE_MODEL_PRODUCT',
                                                    brandId: item?.brandId,
                                                    item: row,
                                                  }));
                                                  return {
                                                    values: values,
                                                    total: data?.total,
                                                  };
                                                });
                                              }}
                                              onChange={(value) => {
                                                const selectedItem = value?.item;
                                                const tmpChargeModelList = [...selectedChargeModelList];
                                                tmpChargeModelList[index] = {
                                                  ...tmpChargeModelList[index],
                                                  id: selectedItem?.modelId,
                                                  modelId: selectedItem?.modelId,
                                                  model: selectedItem?.name,
                                                  serialNumber: selectedItem?.serialNumber,
                                                  serial: selectedItem?.serialNumber,
                                                  type: selectedItem?.type,
                                                  connectorType: selectedItem?.connectorType,
                                                  unit: 'Trụ',
                                                };

                                                setSelectedChargeModelList(tmpChargeModelList);
                                              }}
                                              isDropdownForm={true}
                                              searchable={true}
                                              searchFormClassName="mx-3 my-1 search-form-border"
                                              disabled={!canEdit}
                                            />

                                          </td>
                                          <td
                                            className="border-0 mb-0 pb-0 pr-0"
                                            style={{
                                              minWidth: '100px',
                                            }}
                                          >
                                            <KTFormInput
                                              name={`MODEL_${item?.modelId ?? index}_unit`}
                                              placeholder="Nhập đơn vị tính"
                                              type={KTFormInputType.text}
                                              showUnit={false}
                                              value={item?.unit}
                                              onChange={() => { }}
                                              disabled={true}
                                            />
                                          </td>
                                          <td
                                            className="border-0 mb-0 pb-0 pr-0"
                                            style={{
                                              minWidth: '90px',
                                            }}
                                          >
                                            <KTFormInput
                                              name={`MODEL_${item?.modelId ?? index}_quantity`}
                                              placeholder="Nhập số lượng"
                                              type={KTFormInputType.currency}
                                              showUnit={false}
                                              value={item?.quantity}
                                              onChange={(value) => {
                                                const tmpChargeModelList = [
                                                  ...selectedChargeModelList,
                                                ];
                                                tmpChargeModelList[index].quantity =
                                                  parseInt(value);
                                                setSelectedChargeModelList(tmpChargeModelList);
                                              }}
                                              disabled={!canEdit}
                                            />
                                          </td>
                                          <td
                                            className="border-0 mb-0 pb-0 pr-0"
                                            style={{
                                              minWidth: '170px',
                                            }}
                                          >
                                            <KTFormInput
                                              name={`MODEL_${item?.modelId ?? index}_amount`}
                                              placeholder="Nhập số"
                                              type={KTFormInputType.currency}
                                              value={item?.amount}
                                              onChange={(value) => {
                                                const tmpChargeModelList = [
                                                  ...selectedChargeModelList,
                                                ];
                                                tmpChargeModelList[index].amount = Utils.isValid(
                                                  value
                                                )
                                                  ? parseInt(value)
                                                  : 0;
                                                setSelectedChargeModelList(tmpChargeModelList);
                                              }}
                                              disabled={!canEdit}
                                            />
                                          </td>
                                          <td
                                            className="border-0 mb-0 pb-0 pr-0"
                                            style={{
                                              minWidth: '170px',
                                            }}
                                          >
                                            <KTFormInput
                                              name={`MODEL_${item?.modelId ?? index}_total`}
                                              placeholder="Thành tiền"
                                              type={KTFormInputType.currency}
                                              unit="VNĐ"
                                              value={
                                                _.isNumber(item?.amount)
                                                  ? item?.amount * item?.quantity
                                                  : 0
                                              }
                                              disabled={true}
                                            />
                                          </td>
                                          <td
                                            className="border-0 mb-0 pb-0 pr-0"
                                            style={{
                                              minWidth: '120px',
                                            }}
                                          >
                                            <KTBSDropdown
                                              name={`MODEL_${item?.modelId ?? index}_taxRate`}
                                              toggleElement={
                                                <button
                                                  className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!canEdit ? 'disabled' : ''}`}
                                                  type="button"
                                                >
                                                  {
                                                    _.find(
                                                      AgencyHelper.Data.orderTaxRateOptions,
                                                      (taxRate) => taxRate.value == item?.taxRate
                                                    )?.name || "Chọn thuế suất"
                                                  }
                                                </button>
                                              }
                                              selectedValue={item?.taxRate}
                                              dropdownMenuItems={AgencyHelper.Data.orderTaxRateOptions}
                                              dropdownMenuClassName="overflow-auto w-100 position-relative"
                                              dropdownMenuStyle={{ maxHeight: '30vh' }}
                                              onChange={(value) => {
                                                const tmpChargeModelList = [
                                                  ...selectedChargeModelList,
                                                ];
                                                tmpChargeModelList[index].taxRate = Utils.isValid(value) ? parseInt(value) : 0;
                                                setSelectedChargeModelList(tmpChargeModelList);
                                              }}
                                              isDropdownForm={true}
                                              disabled={!canEdit}
                                            />
                                          </td>
                                          <td className="border-0 pr-5 d-flex flex-column align-items-center justify-content-end mb-0 pb-0">
                                            {UIHelper.buildNegativeButton(
                                              null,
                                              canEdit
                                                ? () => {
                                                  if (selectedChargeModelList.length === 1) {
                                                    setSelectedChargeModelList([
                                                      {
                                                        pointId: null,
                                                        modelId: null,
                                                        amount: 0,
                                                        serialNumber: '',
                                                        model: '',
                                                        quantity: 1,
                                                      },
                                                    ]);
                                                  } else {
                                                    setSelectedChargeModelList(
                                                      _.filter(
                                                        selectedChargeModelList,
                                                        (item, i) => i !== index
                                                      )
                                                    );
                                                  }
                                                }
                                                : null,
                                              <i className="fa-regular fa-trash-can" />
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                    <tr key={`CATEGORY`} className="">
                                      <td
                                        className="border-0 pl-5 mb-0 pb-0 pr-0"
                                        style={{
                                          minWidth: '200px',
                                        }}
                                      >
                                        <KTBSDropdown
                                          name={`CATEGORY`}
                                          toggleElement={
                                            <button
                                              className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between disabled`}
                                              type="button"
                                            >
                                              Chi phí thi công, vật tư lắp đặt, vận chuyển,... dự tính
                                            </button>
                                          }
                                          selectedValue={'Chi phí thi công, vật tư lắp đặt, vận chuyển,... dự tính'}
                                          dropdownMenuItems={[]}
                                          dropdownMenuClassName="overflow-auto w-100 position-relative"
                                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                                          onChange={(value) => { }}
                                          isDropdownForm={true}
                                          disabled={true}
                                        />

                                      </td>
                                      <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                          minWidth: '100px',
                                        }}
                                      >
                                        <KTFormInput
                                          name={`CATEGORY_unit`}
                                          placeholder="Nhập đơn vị tính"
                                          type={KTFormInputType.text}
                                          showUnit={false}
                                          value={'Gói'}
                                          onChange={() => { }}
                                          disabled={true}
                                        />
                                      </td>
                                      <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                          minWidth: '90px',
                                        }}
                                      >
                                        <KTFormInput
                                          name={`CATEGORY_quantity`}
                                          placeholder="Nhập số lượng"
                                          type={KTFormInputType.currency}
                                          showUnit={false}
                                          value={1}
                                          onChange={(value) => { }}
                                          disabled={true}
                                        />
                                      </td>
                                      <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                          minWidth: '170px',
                                        }}
                                      >
                                        <KTFormInput
                                          name={`CATEGORY_amount`}
                                          placeholder="Nhập số"
                                          type={KTFormInputType.currency}
                                          value={categoryAmount}
                                          onChange={(value) => {
                                            setCategoryAmount(
                                              Utils.isValid(value) ? parseInt(value) : ''
                                            );
                                          }}
                                          disabled={!canEdit}
                                        />
                                      </td>
                                      <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                          minWidth: '170px',
                                        }}
                                      >
                                        <KTFormInput
                                          name={`CATEGORY_total`}
                                          placeholder="Thành tiền"
                                          type={KTFormInputType.currency}
                                          unit="VNĐ"
                                          value={Number(categoryAmount) || 0}
                                          disabled={true}
                                        />
                                      </td>
                                      <td
                                        className="border-0 mb-0 pb-0 pr-0"
                                        style={{
                                          minWidth: '120px',
                                        }}
                                      >
                                        <KTBSDropdown
                                          name={`CATEGORY_taxRate`}
                                          toggleElement={
                                            <button
                                              className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between disabled`}
                                              type="button"
                                            >
                                              KCT
                                            </button>
                                          }
                                          selectedValue={'KCT'}
                                          dropdownMenuItems={AgencyHelper.Data.orderTaxRateOptions}
                                          dropdownMenuClassName="overflow-auto w-100 position-relative"
                                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                                          onChange={(value) => { }}
                                          isDropdownForm={true}
                                          disabled={true}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div className="d-flex px-5 mt-4">
                                {UIHelper.buildNegativeButton(
                                  'Thêm sản phẩm',
                                  canEdit
                                    ? () => {
                                      setSelectedChargeModelList([
                                        ...selectedChargeModelList,
                                        {
                                          modelId: null,
                                          amount: 0,
                                          serialNumber: '',
                                          model: '',
                                          type: '',
                                          connectorType: '',
                                          quantity: 1,
                                          unit: '',
                                          taxRate: 0,
                                          tax: 0,
                                          amountBeforeTax: 0,
                                        },
                                      ]);
                                    }
                                    : null,
                                  <i className="fa-regular fa-circle-plus" />
                                )}
                              </div>
                            </div>
                          )}

                          {productType === 'INVESTMENT_PACKAGE' && (
                            <div className="">
                              <div className="table-responsive">
                                <table className="table mb-0">
                                  <thead>
                                    <tr>
                                      <th
                                        className="pl-5"
                                        style={{
                                          ...UIHelper.buildFontStyle(
                                            '600',
                                            '12px',
                                            AppColors.gray[900]
                                          ),
                                          backgroundColor: AppColors.gray[100],
                                          borderTop: `1px solid ${AppColors.gray[300]}`,
                                          borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        }}
                                      >
                                        Gói đầu tư HTKD
                                      </th>
                                      <th
                                        className=""
                                        style={{
                                          ...UIHelper.buildFontStyle(
                                            '600',
                                            '12px',
                                            AppColors.gray[900]
                                          ),
                                          backgroundColor: AppColors.gray[100],
                                          borderTop: `1px solid ${AppColors.gray[300]}`,
                                          borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        }}
                                      >
                                        Đơn giá
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr className="">
                                      <td
                                        className="border-0 pl-5 pr-0"
                                        style={{
                                          minWidth: '200px',
                                        }}
                                      >
                                        <KTBSDropdown
                                          name="PACKAGE_ID"
                                          toggleElement={
                                            <button
                                              className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!canEdit ? 'disabled' : ''
                                                }`}
                                              type="button"
                                            >
                                              {selectedInvestmentPackage
                                                ? _.find(investmentPackageList, (row) =>
                                                  selectedInvestmentPackage?.packageId
                                                    ? row.packageId ===
                                                    selectedInvestmentPackage?.packageId
                                                    : row.packageId === 0
                                                )?.name
                                                : 'Chọn gói đầu tư HTKD'}
                                            </button>
                                          }
                                          selectedValue={
                                            selectedInvestmentPackage
                                              ? selectedInvestmentPackage?.packageId ?? 0
                                              : null
                                          }
                                          dropdownMenuItems={investmentPackageOptions}
                                          dropdownMenuClassName="overflow-auto w-100 position-relative"
                                          dropdownMenuStyle={{ maxHeight: '30vh' }}
                                          onChange={(value) => {
                                            setSelectedInvestmentPackage(
                                              _.find(
                                                investmentPackageList,
                                                (item) => item.packageId === value
                                              )
                                            );
                                          }}
                                          isDropdownForm={true}
                                          disabled={!canEdit}
                                          searchable={true}
                                        />
                                      </td>
                                      <td
                                        className="border-0 pr-5"
                                        style={{
                                          minWidth: '160px',
                                        }}
                                      >
                                        <KTFormInput
                                          name="PACKAGE_AMOUNT"
                                          placeholder="Nhập số"
                                          type={KTFormInputType.currency}
                                          value={selectedInvestmentPackageAmount}
                                          onChange={(value) => {
                                            const amount = Utils.isValid(value)
                                              ? parseInt(value)
                                              : 0;
                                            setSelectedInvestmentPackageAmount(amount);
                                          }}
                                          disabled={!canEdit}
                                        />
                                      </td>
                                      {/* <td className="border-0 pr-5 d-flex flex-column align-items-center justify-content-end">
                                        {UIHelper.buildNegativeButton(
                                          'Xoá',
                                          canEdit
                                            ? () => {
                                                setSelectedInvestmentPackage(null);
                                              }
                                            : null,
                                          <i className="fa-regular fa-trash-can" />
                                        )}
                                      </td> */}
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          )}

                          {productType === 'PREMISE' && (
                            <div style={{
                              borderTop: `1px solid ${AppColors.gray[300]}`,
                            }}>
                              {adminRole && (
                                <div className="radio-inline w-100">
                                  <div className="d-flex align-items-center gap-5">
                                    {UIHelper.buildCardHeader('Thông tin mặt bằng:')}
                                    <KTRadio
                                      name="newPremise"
                                      label="Thêm mặt bằng mới"
                                      type={KTRadioType.outline}
                                      additionalClassName="radio-success"
                                      onChange={(value) => {
                                        setPremiseType('NEW_PREMISE');
                                        setSelectedPremise({
                                          premiseId: null,
                                          name: '',
                                          type: '',
                                          floorArea: '',
                                          vehicleTypes: '',
                                          rentingType: '',
                                          parkingSlots: '',
                                          rentalForm: 'Có phí',
                                          areaId: null,
                                          address: '',
                                          description: '',
                                          monthlyRent: 0,
                                          slotRent: 0,
                                        })
                                        setSelectedInvestor(null);
                                      }}
                                      checked={premiseType === 'NEW_PREMISE'}
                                      disabled={editMode}
                                    />
                                    <KTRadio
                                      name="createdPremise"
                                      label="Mặt bằng đã tạo"
                                      type={KTRadioType.outline}
                                      additionalClassName="radio-success"
                                      onChange={(value) => {
                                        setPremiseType('CREATED_PREMISE');
                                      }}
                                      checked={premiseType === 'CREATED_PREMISE'}
                                      disabled={editMode}
                                    />
                                  </div>
                                </div>
                              )}

                              {premiseType === 'CREATED_PREMISE' && (
                                <div className='p-4'
                                  style={{
                                    borderTop: adminRole ? `1px dashed ${AppColors.gray[300]}` : ''
                                  }}>
                                  {UIHelper.buildFormLabel('Mặt bằng', true)}
                                  <CustomDropdown2
                                    ignoreConfirmClick={true}
                                    name="premiseId"
                                    id="premiseId"
                                    toggleElement={
                                      <button
                                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                                        type="button"
                                      >
                                        {selectedPremise?.name?.length ? selectedPremise?.name : 'Chọn mặt bằng'}
                                      </button>
                                    }
                                    selectedValue={selectedPremise}
                                    subTitleType="address"
                                    dropdownMenuItems={buyerDropdownMenuItems}
                                    getSubItems={async (item) => {
                                      try {
                                        const param = {
                                          role: item?.role,
                                          page: item?.page || 0,
                                          limit: 10,
                                          q: item?.q || '',
                                        };
                                        return await AgencyHelper.API.requestGetPremiseList(param).then(
                                          (data) => {
                                            return {
                                              values: data.premises?.map((row) => ({
                                                id: row?.premiseId,
                                                name: row?.name,
                                                item: row,
                                                address: ChargeHelper.Utils.getChargeStationFullAddress(row),
                                              })),
                                              total: data?.total,
                                            };
                                          }
                                        );
                                      } catch (error) {
                                        console.error('Error fetching premise list:', error);
                                        return { values: [], total: 0 };
                                      }
                                    }}
                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    onChange={(value) => {
                                      const isValidPremise = handleCheckSelectedPremise(value?.item);
                                      if (isValidPremise) {
                                        setSelectedPremise({
                                          premiseId: value?.item?.premiseId,
                                          name: value?.item?.name,
                                          type: value?.item?.type,
                                          floorArea: value?.item?.floorArea,
                                          vehicleTypes: value?.item?.vehicleTypes?.join(','),
                                          rentingType: value?.item?.rentingType,
                                          parkingSlots: value?.item?.parkingSlots,
                                          rentalForm: value?.item?.rentalForm,
                                          areaId: value?.item?.areaId,
                                          address: value?.item?.address,
                                          description: value?.item?.description,
                                          monthlyRent: value?.item?.monthlyRent,
                                          slotRent: value?.item?.slotRent,
                                        });

                                        DealerHelper.callApiGetAgencyDetail(value?.item?.landlordId).then((data) => {
                                          if (Object.keys(data)?.length > 0) {
                                            setSelectedInvestor({
                                              id: data?.agencyId,
                                              name: data?.name,
                                              item: data,
                                              email: data?.email,
                                            })
                                          }
                                        })
                                      }
                                    }}
                                    isDropdownForm={true}
                                    searchable={true}
                                    searchFormClassName="mx-3 my-1 search-form-border"
                                    disabled={!canEdit}
                                    defaultValue={buyerDropdownDefaultItem}
                                    dependItem={selectedAgency}
                                  />
                                </div>
                              )}

                              {premiseType === 'NEW_PREMISE' && (
                                <div className='p-4'
                                  style={{
                                    borderTop: adminRole ? `1px dashed ${AppColors.gray[300]}` : ''
                                  }}>
                                  <AgencySaleAddPremiseView
                                    setSelectedPremise={setSelectedPremise}
                                    selectedPremise={selectedPremise}
                                    readyToValidData={readyToValidData}
                                    selectedAreaProvince={selectedAreaProvince}
                                    setSelectedAreaProvince={setSelectedAreaProvince}
                                    selectedAreaDistrict={selectedAreaDistrict}
                                    setSelectedAreaDistrict={setSelectedAreaDistrict}
                                    commissionGrounds={commissionGrounds}
                                    disabled={!canEdit}
                                  />
                                </div>
                              )}
                            </div>
                          )}

                          {productType === 'CHARGEPOINT' && (
                            <div className="mb-4">
                              <div className="table-responsive">
                                <table className="table mb-0">
                                  <thead>
                                    <tr>
                                      <th
                                        className="pl-5"
                                        style={{
                                          ...UIHelper.buildFontStyle(
                                            '600',
                                            '12px',
                                            AppColors.gray[900]
                                          ),
                                          backgroundColor: AppColors.gray[100],
                                          borderTop: `1px solid ${AppColors.gray[300]}`,
                                          borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        }}
                                      >
                                        Sản phẩm
                                      </th>
                                      <th
                                        className=""
                                        style={{
                                          ...UIHelper.buildFontStyle(
                                            '600',
                                            '12px',
                                            AppColors.gray[900]
                                          ),
                                          backgroundColor: AppColors.gray[100],
                                          borderTop: `1px solid ${AppColors.gray[300]}`,
                                          borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        }}
                                      >
                                        Số lượng
                                      </th>
                                      <th
                                        className=""
                                        style={{
                                          ...UIHelper.buildFontStyle(
                                            '600',
                                            '12px',
                                            AppColors.gray[900]
                                          ),
                                          backgroundColor: AppColors.gray[100],
                                          borderTop: `1px solid ${AppColors.gray[300]}`,
                                          borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        }}
                                      >
                                        Đơn giá
                                      </th>
                                      <th
                                        className=""
                                        style={{
                                          ...UIHelper.buildFontStyle(
                                            '600',
                                            '12px',
                                            AppColors.gray[900]
                                          ),
                                          backgroundColor: AppColors.gray[100],
                                          borderTop: `1px solid ${AppColors.gray[300]}`,
                                          borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        }}
                                      >
                                        Thành tiền
                                      </th>
                                      <th
                                        className="pr-5 w-40px"
                                        style={{
                                          ...UIHelper.buildFontStyle(
                                            '600',
                                            '12px',
                                            AppColors.gray[900]
                                          ),
                                          backgroundColor: AppColors.gray[100],
                                          borderTop: `1px solid ${AppColors.gray[300]}`,
                                          borderBottom: `1px solid ${AppColors.gray[300]}`,
                                        }}
                                      ></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {selectedChargePointList.map((item, index) => {
                                      return (
                                        <tr key={`POINT_${index}`} className="">
                                          <td
                                            className="border-0 pl-5 mb-0 pb-0 pr-0"
                                            style={{
                                              minWidth: '200px',
                                            }}
                                          >
                                            <CustomDropdown2
                                              ignoreConfirmClick={true}
                                              name={`POINT_${index}`}
                                              id={`POINT_${index}`}
                                              toggleElement={
                                                <button
                                                  className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!canEdit ? 'disabled' : ''
                                                    }`}
                                                  type="button"
                                                >
                                                  {item?.modelId
                                                    ? `[${item?.type}] ${item?.model}`
                                                    : 'Chọn dòng trụ sạc'}
                                                </button>
                                              }
                                              selectedValue={item}
                                              dropdownMenuItems={chargeBrandOptions}
                                              dropdownMenuClassName="overflow-auto w-100 position-relative"
                                              dropdownMenuStyle={{ maxHeight: '30vh' }}
                                              titleSearchable={true}
                                              defaultTitle="Chọn hãng sản xuất trụ sạc"
                                              getSubItems={async (item) => {
                                                return chargeModelApi.getChargeModelList(
                                                  Utils.filterParams({
                                                    brandId: item?.role,
                                                    page: item?.page || 0,
                                                    limit: 10,
                                                    q: item?.q || '',
                                                  })
                                                ).then((data) => {
                                                  let values = data.models?.map((row) => ({
                                                    id: row?.modelId,
                                                    name: `[${row?.type}] ${row?.name}`,
                                                    item: row,
                                                  }));
                                                  return {
                                                    values: values,
                                                    total: data?.total,
                                                  };
                                                });
                                              }}
                                              onChange={(value) => {
                                                const cm = value?.item;
                                                const tmpChargePointList = [
                                                  ...selectedChargePointList,
                                                ];
                                                tmpChargePointList[index] = {
                                                  ...tmpChargePointList[index],
                                                  id: cm?.modelId,
                                                  modelId: cm?.modelId,
                                                  model: cm?.name,
                                                  serialNumber: cm?.serialNumber,
                                                  serial: cm?.serialNumber,
                                                  type: cm?.type,
                                                  connectorType: cm?.connectorType,
                                                };
                                                setSelectedChargePointList(tmpChargePointList);
                                              }}
                                              isDropdownForm={true}
                                              searchable={true}
                                              searchFormClassName="mx-3 my-1 search-form-border"
                                              disabled={!canEdit}
                                            />
                                          </td>
                                          <td
                                            className="border-0 mb-0 pb-0 pr-0"
                                            style={{
                                              minWidth: '80px',
                                            }}
                                          >
                                            <KTFormInput
                                              name={`POINT_${item?.modelId ?? index}_quantity`}
                                              placeholder="Nhập số lượng"
                                              type={KTFormInputType.currency}
                                              showUnit={false}
                                              value={item?.quantity}
                                              onChange={(value) => {
                                                const tmpChargePointList = [
                                                  ...selectedChargePointList,
                                                ];
                                                tmpChargePointList[index].quantity =
                                                  parseInt(value);
                                                setSelectedChargePointList(tmpChargePointList);
                                              }}
                                              disabled={!canEdit}
                                            />
                                          </td>
                                          <td
                                            className="border-0 mb-0 pb-0 pr-0"
                                            style={{
                                              minWidth: '160px',
                                            }}
                                          >
                                            <KTFormInput
                                              name={`POINT_${item?.modelId ?? index}_amount`}
                                              placeholder="Nhập số"
                                              type={KTFormInputType.currency}
                                              value={item?.amount}
                                              onChange={(value) => {
                                                const tmpChargePointList = [
                                                  ...selectedChargePointList,
                                                ];
                                                tmpChargePointList[index].amount = Utils.isValid(
                                                  value
                                                )
                                                  ? parseInt(value)
                                                  : 0;
                                                setSelectedChargePointList(tmpChargePointList);
                                              }}
                                              disabled={!canEdit}
                                            />
                                          </td>
                                          <td
                                            className="border-0 mb-0 pb-0 pr-0"
                                            style={{
                                              minWidth: '160px',
                                            }}
                                          >
                                            <KTFormInput
                                              name={`POINT_${item?.modelId ?? index}_total`}
                                              placeholder="Thành tiền"
                                              type={KTFormInputType.currency}
                                              unit="VNĐ"
                                              value={
                                                _.isNumber(item?.amount)
                                                  ? item?.amount * item?.quantity
                                                  : 0
                                              }
                                              disabled={true}
                                            />
                                          </td>
                                          <td className="border-0 pr-5 d-flex flex-column align-items-center justify-content-end mb-0 pb-0">
                                            {UIHelper.buildNegativeButton(
                                              null,
                                              canEdit
                                                ? () => {
                                                  if (selectedChargePointList.length === 1) {
                                                    setSelectedChargePointList([
                                                      {
                                                        pointId: null,
                                                        modelId: null,
                                                        amount: 0,
                                                        serialNumber: '',
                                                        model: '',
                                                        quantity: 1,
                                                      },
                                                    ]);
                                                  } else {
                                                    setSelectedChargePointList(
                                                      _.filter(
                                                        selectedChargePointList,
                                                        (item, i) => i !== index
                                                      )
                                                    );
                                                  }
                                                }
                                                : null,
                                              <i className="fa-regular fa-trash-can" />
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                              <div className="d-flex px-5 mt-4">
                                {UIHelper.buildNegativeButton(
                                  'Thêm dòng trụ sạc',
                                  canEdit
                                    ? () => {
                                      setSelectedChargePointList([
                                        ...selectedChargePointList,
                                        {
                                          pointId: null,
                                          modelId: null,
                                          amount: 0,
                                          serialNumber: '',
                                          quantity: 1,
                                        },
                                      ]);
                                    }
                                    : null,
                                  <i className="fa-regular fa-circle-plus" />
                                )}
                              </div>
                            </div>
                          )}
                        </motion.div>
                      </AnimatePresence>

                      {/* thanh tien */}
                      {productType !== 'PREMISE' && (
                        <div
                          className="px-4 py-3 d-flex align-items-center justify-content-end"
                          style={{
                            borderTop: `1px dashed ${AppColors.gray[300]}`,
                          }}
                        >
                          {(productType === 'CHARGE_MODEL' || productType === 'COINVESTOR')
                            ? (
                              <div className='w-60 d-flex flex-column'>
                                <div className='w-100 d-flex'>
                                  <div className='w-50 d-flex flex-column'>
                                    <span style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[800])}>
                                      Tổng tiền trụ sạc (trước thuế):{' '}
                                    </span>
                                    <span style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[800])}>
                                      Tổng tiền trang thiết bị & dịch vụ (trước thuế):{' '}
                                    </span>
                                    <span style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[800])}>
                                      Thuế VAT:{' '}
                                    </span>
                                  </div>
                                  <div className='w-50 d-flex flex-column'>
                                    <span style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[900])}>
                                      {Utils.formatNumber(chargeModelAmount ?? 0)} VNĐ
                                    </span>
                                    <span style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[900])}>
                                      {Utils.formatNumber(Number(categoryAmount) || 0)} VNĐ
                                    </span>
                                    <span style={UIHelper.buildFontStyle('600', '13px', AppColors.gray[900])}>
                                      {Utils.formatNumber(taxAmount ?? 0)} VNĐ
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className='w-100 d-flex py-3'
                                  style={{
                                    borderTop: `1px dashed ${AppColors.gray[300]}`,
                                  }}
                                >
                                  <div className='w-50 d-flex flex-column'>
                                    <span style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[800])}>
                                      Tổng tiền đơn hàng:{' '}
                                    </span>
                                  </div>
                                  <div className='w-50 d-flex flex-column'>
                                    <span style={UIHelper.buildFontStyle('600', '18px', AppColors.primary)}>
                                      {Utils.formatNumber(Number(amountAfterTax) || 0)} VNĐ
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )
                            : (
                              <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[900])}>
                                Tổng tiền:{' '}
                                <span style={UIHelper.buildFontStyle('700', '26px', AppColors.primary)}>
                                  {Utils.formatNumber(amount ?? 0)} VNĐ
                                </span>
                              </span>
                            )}
                        </div>
                      )}
                    </div>,
                    false
                  )}

                  {/* thong tin cac ben tham gia */}
                  <div className="mt-4">
                    <div>
                      <div className="row m-0 p-0">
                        {/* ben ban */}
                        {/* dai ly ban hang */}
                        <div className="col-lg-6 pl-0 pr-0 pr-lg-2 mb-4">
                          {UIHelper.buildCard(
                            <div>
                              {UIHelper.buildCardHeader(productType === 'PREMISE' ? 'Thông tin bên giới thiệu' : 'Thông tin bên bán', true)}
                              <div className="px-5 pt-3 pb-6 d-flex flex-column gap-3">
                                <div>
                                  {UIHelper.buildFormLabel(productType === 'PREMISE' ? 'Người giới thiệu' : 'Đối tượng bán hàng', true)}
                                  {/* NEW */}
                                  <CustomDropdown2
                                    ignoreConfirmClick={true}
                                    name="agencyId"
                                    id="agencyId"
                                    toggleElement={
                                      <button
                                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${(editMode || isSellerPrefilled)
                                          ? 'disabled'
                                          : ''
                                          }`}
                                        type="button"
                                      >
                                        {selectedAgency?.name || (productType === 'PREMISE' ? 'Chọn người giới thiệu' : 'Chọn đối tượng bán hàng')}
                                      </button>
                                    }
                                    selectedValue={selectedAgency}
                                    subTitleType="email"
                                    dropdownMenuItems={sellerDropdownMenuItems}
                                    getSubItems={async (item) => {
                                      return AgencyHelper.API.requestGetAgencyList(
                                        Utils.filterParams({
                                          role: item?.role,
                                          page: item?.page || 0,
                                          limit: 10,
                                          q: item?.q || '',
                                          deepLevel: !isAdmin ? user?.agency?.deepLevel + 1 : '',
                                          status: 'NORMAL',
                                        })
                                      ).then((data) => {
                                        let values = data.agencies?.map((row) => ({
                                          id: row?.agencyId,
                                          name: row?.name,
                                          item: row,
                                          email: row?.email,
                                        }));
                                        if (
                                          isAgency &&
                                          isSale &&
                                          (!Utils.isValid(item?.page) ||
                                            _.toNumber(item?.page) === 0)
                                        ) {
                                          // neu la dai ly ban hang thi cho chinh no o dau
                                          values = [
                                            {
                                              id: user?.agency?.agencyId,
                                              name: user?.agency?.name,
                                              item: user?.agency,
                                              email: user?.agency?.email,
                                            },
                                            ...values,
                                          ];
                                        }
                                        return {
                                          values: values,
                                          total: data?.total,
                                        };
                                      });
                                    }}
                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    onChange={(value) => {
                                      // if (value?.value === user?.agency?.agencyId) {
                                      //   setSelectedAgency({
                                      //     id: user?.agency?.agencyId,
                                      //     name: user?.agency?.name,
                                      //     item: user?.agency,
                                      //   });
                                      // } else {
                                      setSelectedAgency(value);
                                      // }
                                    }}
                                    isDropdownForm={true}
                                    searchable={true}
                                    searchFormClassName="mx-3 my-1 search-form-border"
                                    disabled={editMode || isSellerPrefilled}
                                    direction={CustomDropdown2Directions.up}
                                  />
                                </div>

                                <div>
                                  {UIHelper.buildFormLabel('Số điện thoại')}
                                  <KTFormInput
                                    name="agencyPhone"
                                    placeholder="Nhập số điện thoại"
                                    type={KTFormInputType.telephone}
                                    value={selectedAgency?.item?.phone}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>,
                            false
                          )}
                        </div>
                        {/* ben mua */}
                        <div className="col-lg-6 pr-0 pl-0 pl-lg-2 mb-4">
                          {UIHelper.buildCard(
                            <div>
                              {UIHelper.buildCardHeader(
                                <div className='d-flex flex-column gap-2'>
                                  <span>
                                    {productType === 'PREMISE' ? 'Thông tin bên cho thuê' : 'Thông tin bên mua'}
                                  </span>
                                  {(!editMode && isAgency && isSale && canChangeProductType && productType !== 'PREMISE' && productType !== 'CHARGEPOINT') && (
                                    <div className="radio-inline w-100">
                                      <div className="d-flex align-items-center gap-5">
                                        <KTRadio
                                          name="modeOnlySubInvestor"
                                          label="Đối tượng bán hàng quản lý"
                                          type={KTRadioType.outline}
                                          additionalClassName="radio-success mb-0"
                                          onChange={(value) => {
                                            setModeOnlySubInvestor(true);
                                          }}
                                          checked={modeOnlySubInvestor}
                                        />
                                        <KTRadio
                                          name="modeAllSubInvestor"
                                          label="Đối tượng khác quản lý"
                                          type={KTRadioType.outline}
                                          additionalClassName="radio-success mb-0"
                                          onChange={(value) => {
                                            setModeOnlySubInvestor(false);
                                          }}
                                          checked={!modeOnlySubInvestor}
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {!editMode && isAgency && !isSale && canChangeProductType && productType !== 'CHARGEPOINT' && (
                                    <div className="radio-inline w-100">
                                      <div className="d-flex align-items-center gap-5">
                                        <KTRadio
                                          name="modeOnlySubInvestor"
                                          label="NĐT bạn quản lý"
                                          type={KTRadioType.outline}
                                          additionalClassName="radio-success mb-0"
                                          onChange={(value) => {
                                            setModeOnlySubInvestor(true);
                                          }}
                                          checked={modeOnlySubInvestor}
                                        />
                                        <KTRadio
                                          name="modeAllSubInvestor"
                                          label="NĐT khác"
                                          type={KTRadioType.outline}
                                          additionalClassName="radio-success mb-0"
                                          onChange={(value) => {
                                            setModeOnlySubInvestor(false);
                                          }}
                                          checked={!modeOnlySubInvestor}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>,
                                true
                              )}

                              <div className="px-5 pt-3 pb-6 d-flex flex-column gap-3">
                                {productType === 'CHARGEPOINT' && (
                                  <div>
                                    {UIHelper.buildFormLabel('Loại đối tác', true)}
                                    <KTBSDropdown
                                      name="partnerType"
                                      toggleElement={
                                        <button
                                          className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between 
                                            ${(!canEdit || !!initialAgencyChargePointId) ? 'dropdown-disabled' : ''}`}
                                          type="button"
                                        >
                                          {_.find(
                                            AgencyHelper.Data.partnerTypeOptions,
                                            (item) => item.value === buyerDropdownDefaultItem?.role
                                          )?.name ?? 'Chọn loại đối tác'}
                                        </button>
                                      }
                                      selectedValue={buyerDropdownDefaultItem?.role}
                                      dropdownMenuItems={AgencyHelper.Data.partnerTypeOptions}
                                      dropdownMenuClassName="overflow-auto w-100"
                                      dropdownMenuStyle={{ maxHeight: '30vh' }}
                                      onChange={(value) => {
                                        setBuyerDropdownDefaultItem({
                                          name: _.find(
                                            AgencyHelper.Data.partnerTypeOptions,
                                            (item) => item.value === buyerDropdownDefaultItem?.role
                                          )?.name ?? '',
                                          role: value,
                                          modeOnlySubInvestor,
                                        });
                                        setSelectedInvestor(null);
                                      }}
                                      isDropdownForm={true}
                                      isabled={editMode || !canChangeProductType}
                                    />
                                  </div>
                                )}
                                <div>
                                  {UIHelper.buildFormLabel(
                                    productType === 'PREMISE'
                                      ? 'Chủ mặt bằng'
                                      : productType === 'CHARGEPOINT'
                                        ? 'Đối tác mua trụ sạc'
                                        : 'Nhà đầu tư ' +
                                        (productType === 'INVESTMENT_PACKAGE'
                                          ? 'HTKD'
                                          : productType === 'CHARGE_MODEL'
                                            ? 'NQ'
                                            : 'liên kết'),
                                    true
                                  )}
                                  {/* NEW */}
                                  <CustomDropdown2
                                    ignoreConfirmClick={true}
                                    name="buyerId"
                                    id="buyerId"
                                    toggleElement={
                                      <button
                                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${(editMode || isBuyerPrefilled)
                                          ? 'disabled'
                                          : ''
                                          } ${!investorReadyToPurchase ? 'button-invalid' : ''}`}
                                        type="button"
                                      >
                                        {selectedInvestor?.name ||
                                          (productType === 'PREMISE'
                                            ? 'Chọn chủ mặt bằng'
                                            : productType === 'CHARGEPOINT'
                                              ? 'Chọn đối tác mua trụ sạc'
                                              : `Chọn nhà đầu tư ${productType === 'INVESTMENT_PACKAGE'
                                                ? 'HTKD'
                                                : productType === 'CHARGE_MODEL'
                                                  ? 'NQ'
                                                  : 'liên kết'}`)}
                                      </button>
                                    }
                                    selectedValue={selectedInvestor}
                                    subTitleType="email"
                                    dropdownMenuItems={buyerDropdownMenuItems}
                                    getSubItems={async (item) => {
                                      if (modeOnlySubInvestor) {
                                        // ban cho NDT cua ban
                                        const param = {
                                          role: item?.role,
                                          page: item?.page || 0,
                                          limit: 10,
                                          q: item?.q || '',
                                          status: 'NORMAL',
                                        };
                                        if (isAgency && productType !== 'CHARGEPOINT') {
                                          param.parentAgencyId = selectedAgency?.id;
                                        }
                                        return AgencyHelper.API.requestGetAgencyList(param).then(
                                          (data) => {
                                            return {
                                              values: data.agencies?.map((row) => ({
                                                id: row?.agencyId,
                                                name: row?.name,
                                                item: row,
                                                email: row?.email,
                                              })),
                                              total: data?.total,
                                            };
                                          }
                                        );
                                      } else {
                                        // ban cho NDT khac
                                        const param = {
                                          role: item?.role,
                                          page: item?.page || 0,
                                          limit: 10,
                                          q: item?.q || '',
                                          managedBy: (productType === 'PREMISE' || productType === 'CHARGEPOINT') ? 'ALL' : 'OTHER',
                                          agencyId: selectedAgency?.id,
                                          status: 'NORMAL',
                                        };
                                        if (param.q?.length > 0) {
                                          return AgencyHelper.API.requestSearchAgency(param).then(
                                            (data) => {
                                              return {
                                                values: data.agencies?.map((row) => ({
                                                  id: row?.agencyId,
                                                  name: row?.name,
                                                  item: row,
                                                  email: row?.email,
                                                })),
                                                total: data?.total,
                                              };
                                            }
                                          );
                                        }
                                      }
                                    }}
                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    onChange={(value) => {
                                      setSelectedInvestor(value);
                                    }}
                                    isDropdownForm={true}
                                    searchable={true}
                                    searchFormClassName="mx-3 my-1 search-form-border"
                                    disabled={editMode || isBuyerPrefilled}
                                    defaultValue={buyerDropdownDefaultItem}
                                    dependItem={selectedAgency}
                                    direction={CustomDropdown2Directions.up}
                                  />
                                </div>
                                <div>
                                  {UIHelper.buildFormLabel('Số điện thoại')}
                                  <KTFormInput
                                    name="buyerPhone"
                                    placeholder="Nhập số điện thoại"
                                    type={KTFormInputType.telephone}
                                    value={selectedInvestor?.item?.phone}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>,
                            false
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* thong tin don hang & tap tin dinh kem */}
                <div className="col-lg-4 pr-0 pl-0 pl-lg-4"
                  style={{
                    backgroundColor: (productType === 'CHARGE_MODEL' || productType === 'COINVESTOR') ? 'rgba(238, 241, 250, 1)' : '',
                    zIndex: 101
                  }}>
                  {UIHelper.buildCard(
                    <div>
                      {/* {UIHelper.buildCardHeader('Thông tin đơn hàng', true)} */}
                      <div className="px-5 pt-3 pb-5 d-flex flex-column gap-3">
                        {editMode && (
                          <div>
                            {UIHelper.buildFormLabel('Trạng thái đơn hàng', true)}
                            <KTBSDropdown
                              name="orderStatus"
                              toggleElement={
                                <button
                                  className={`${(!isAdmin || !editMode || !canChangeStatus)
                                    ? 'disabled' : ''
                                    } btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!isAdmin && 'dropdown-disabled'}`}
                                  type="button"
                                >
                                  {
                                    _.find(
                                      AgencyHelper.Data.premiseOrderStatusOptions,
                                      (item) => item.value === orderStatus
                                    ).name
                                  }
                                </button>
                              }
                              selectedValue={orderStatus}
                              dropdownMenuItems={orderStatusOptions}
                              dropdownMenuClassName="overflow-auto w-100"
                              dropdownMenuStyle={{ maxHeight: '30vh' }}
                              onChange={(value) => {
                                setOrderStatus(value);
                              }}
                              isDropdownForm={true}
                              disabled={!isAdmin || !editMode || !canChangeStatus}
                            />
                          </div>
                        )}
                        <div>
                          {UIHelper.buildFormLabel('Ghi chú')}
                          <KTFormTextArea
                            name="note"
                            placeholder="Nhập ghi chú"
                            value={note}
                            onChange={(value) => setNote(value)}
                          />
                        </div>
                        {productType === 'INVESTMENT_PACKAGE' && (
                          <>
                            {/* <div>
                              {UIHelper.buildFormLabel('Ngày hiệu lực', true)}
                              <KTFormInput
                                name="contractValidFrom"
                                placeholder="Nhập ngày hiệu lực"
                                type={KTFormInputType.date}
                                value={validFrom}
                                onChange={(value) => setValidFrom(value)}
                                disabled={editMode}
                              />
                            </div>
                            <div className="mb-3">
                              {UIHelper.buildFormLabel('Ngày hết hiệu lực', true)}
                              <KTFormInput
                                name="contractValidTo"
                                placeholder="Nhập ngày hết hiệu lực"
                                type={KTFormInputType.date}
                                value={validTo}
                                onChange={(value) => setValidTo(value)}
                                disabled={editMode}
                              />
                            </div> */}
                          </>
                        )}
                      </div>
                    </div>,
                    false
                  )}

                  {/* tap tin dinh kem */}
                  <div className="mt-4">
                    {UIHelper.buildCard(
                      <div>
                        {UIHelper.buildCardHeader('Tập tin đính kèm', true)}
                        <div>
                          {/* danh sach file dang duoc chon */}
                          {!_.isEmpty(allFiles) && (
                            <div className="row m-0 p-0 mt-2 px-3">
                              {allFiles.map((item, index) => {
                                return (
                                  <div
                                    className="p-0 col-6 mb-2 p-2"
                                    key={item?.lastModified ?? item ?? index}
                                  >
                                    <ImageView
                                      name={item?.lastModified ?? item ?? index}
                                      path={_.isString(item) ? item : item?.name}
                                      onRemove={() => {
                                        handleRemoveFile(item);
                                      }}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          )}
                          <div className="d-flex px-4 py-3">
                            <label className="">
                              {UIHelper.buildNegativeButton(
                                'Thêm tập tin',
                                () => { },
                                <i className="fa-regular fa-upload" />
                              )}
                              <input
                                type="file"
                                accept={['.xls', '.xlsx', '.doc', '.docx', '.pdf']}
                                onChange={handleFilesChanged}
                                multiple
                                hidden
                                onClick={(e) => {
                                  e.target.value = null;
                                }}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div>
            <EmptyView
              icon={imgEmptyNoData}
              title="Không có quyền truy cập"
              text={<span>Tài khoản hiện tại không có quyền tạo và chỉnh sửa đơn hàng.</span>}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default AgencySaleAddOrderView;
